// import React, { useEffect, useRef, useState } from "react";
// import { useLocation } from "react-router-dom";
// import axios from "axios";
// import HeaderBar from "../../HeaderBar/HeaderBar";
// import styles from "./Fileinfo.module.css";
// import { FiDownload, FiTrash2 } from "react-icons/fi";
// import {
//   addKnowledgeBaseSources,
//   deleteAgentFile,
//   deleteKnowledgeBaseSource,
//   getAgentFiles,
//   getKnowledgeBase,
//   uploadAgentFiles,
// } from "../../../Store/apiStore";
// // new
// import PopUp from "../../Popup/Popup";

// import Loader from "../../Loader/Loader";
// import Loader2 from "../../Loader2/Loader2";

// const MAX_FILES = 1;
// const MAX_FILE_SIZE_MB = 10;

// // KB upload formats — UI text, accept attribute aur validation teeno yahin se
// // aate hain, taki list ek hi jagah maintain ho.
// // Purani (poori) list future reference ke liye:
// // bmp, csv, doc, docx, eml, epub, heic, html, jpeg, png, md, msg, odt, org,
// // p7s, pdf, ppt, pptx, rst, rtf, tiff, txt, tsv, xls, xlsx, xml
// const ALLOWED_EXTENSIONS = [
//   "pdf", "txt", "md", "csv", "xlsx", "xls", "json", "jpeg", "jpg", "png",
// ];
// const ACCEPT_ATTR = ALLOWED_EXTENSIONS.map((x) => "." + x).join(",");
// const SUPPORTED_LABEL = ALLOWED_EXTENSIONS.map((x) => "." + x).join(", ");

// const getExtension = (fileName) => {
//   const name = String(fileName || "");
//   const dot = name.lastIndexOf(".");
//   // Bina extension ke naam ("report") ya dot se shuru hone wale (".env") reject.
//   if (dot <= 0) return "";
//   return name.slice(dot + 1).toLowerCase();
// };

// const isAllowedFile = (fileName) =>
//   ALLOWED_EXTENSIONS.includes(getExtension(fileName));

// // Backend get-agent-files har file ke liye "application/octet-stream" lautata hai,
// // isliye extension se asli type nikalte hain — Retell isi ke basis par parse karta hai.
// const MIME_BY_EXT = {
//   pdf: "application/pdf",
//   txt: "text/plain",
//   md: "text/markdown",
//   csv: "text/csv",
//   tsv: "text/tab-separated-values",
//   json: "application/json",
//   xml: "application/xml",
//   html: "text/html",
//   rtf: "application/rtf",
//   doc: "application/msword",
//   docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
//   xls: "application/vnd.ms-excel",
//   xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   ppt: "application/vnd.ms-powerpoint",
//   pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
//   odt: "application/vnd.oasis.opendocument.text",
//   epub: "application/epub+zip",
//   eml: "message/rfc822",
//   msg: "application/vnd.ms-outlook",
//   png: "image/png",
//   jpg: "image/jpeg",
//   jpeg: "image/jpeg",
//   bmp: "image/bmp",
//   tiff: "image/tiff",
//   heic: "image/heic",
// };

// const guessMimeType = (fileName, fallback) => {
//   const ext = (fileName?.split(".").pop() || "").toLowerCase();
//   return (
//     MIME_BY_EXT[ext] ||
//     (fallback && fallback !== "application/octet-stream" ? fallback : null) ||
//     "application/octet-stream"
//   );
// };

// const Fileinfo = () => {
//   const location = useLocation();
//   // const { agent_id, knowledgeBaseId } = location.state || {};
//     const { agent_id, knowledgeBaseId: initialKnowledgeBaseId } = location.state || {};
//   const [knowledgeBaseSources, setKnowledgeBaseSources] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [submitLoading, submitSetLoading] = useState(false);
//   const [cancelButtonHeading, setCancelButtonHeading] = useState(false);
//   const [inlineError, setInlineError] = useState("");
//   const [isModalDisabled, setIsModalDisabled] = useState(false);
//   const token = localStorage.getItem("token");
//   const [knowledgeBaseId, setKnowledgeBaseId] = useState(initialKnowledgeBaseId);

//   // Polling interval ka handle — unmount/naye poll par clear karne ke liye.
//   const pollRef = useRef(null);

//   const [popup, setPopup] = useState({
//     show: false,
//     type: "",
//     message: "",
//     onConfirm: null,
//   });
//   const closePopup = () => {
//     setPopup({ show: false, type: "", message: "", onConfirm: null });
//   };

//   const fetchKnowledgeBaseDetails = async (kbId = knowledgeBaseId) => {
//     // Agent ke paas abhi koi KB nahi hai -> loader band karke empty state dikhao,
//     // warna spinner hamesha ke liye atka reh jaata hai.
//     if (!kbId) {
//       setKnowledgeBaseSources([]);
//       setLoading(false);
//       return;
//     }
//     setLoading(true);
//     try {
//       const response = await getKnowledgeBase(token, kbId);
//       // getKnowledgeBase error par { success:false } deta hai (data ke bina),
//       // isliye optional chaining zaroori hai.
//       setKnowledgeBaseSources(response?.data?.knowledge_base_sources || []);
//     } catch (error) {
//       console.error("Failed to fetch knowledge base details:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const stopPolling = () => {
//     if (pollRef.current) {
//       clearInterval(pollRef.current);
//       pollRef.current = null;
//     }
//   };

//   const startPollingStatus = (kbId) => {
//     if (!kbId) return;
//     stopPolling();
//     // ~2 min tak poll karo; Retell "in_progress" par atak jaaye to bhi
//     // screen unblock rahe aur jo sources mile woh dikh jaayein.
//     let attempts = 0;
//     const MAX_ATTEMPTS = 24;

//     const tick = async () => {
//       attempts += 1;
//       try {
//         const response = await getKnowledgeBase(token, kbId);

//         if (response?.success) {
//           // Har tick par list update karo — "complete" hone ka wait mat karo,
//           // warna indexing chalne tak nayi file dikhti hi nahi.
//           setKnowledgeBaseSources(
//             response?.data?.knowledge_base_sources || []
//           );
//           setLoading(false);

//           if (response?.data?.status === "complete") {
//             stopPolling();
//             return;
//           }
//         }
//       } catch (error) {
//         console.error("Error while polling KB status:", error);
//       }

//       if (attempts >= MAX_ATTEMPTS) stopPolling();
//     };

//     // Pehla check turant — setInterval warna 5s baad hi chalta.
//     tick();
//     pollRef.current = setInterval(tick, 5000);
//   };

//   useEffect(() => {
//     fetchKnowledgeBaseDetails(knowledgeBaseId);
//   }, [knowledgeBaseId]);

//   // Unmount par polling band — warna background interval chalta rehta hai.
//   useEffect(() => stopPolling, []);
//   const handleFileChange = (e) => {
//     setInlineError("");
//     const newFiles = Array.from(e.target.files);
//     let validFiles = [];
//     let oversizedFiles = [];
//     let unsupportedFiles = [];

//     // Validate file type + size
//     newFiles.forEach((file) => {
//       if (!isAllowedFile(file.name)) {
//         unsupportedFiles.push(file.name);
//       } else if (file.size / (1024 * 1024) > MAX_FILE_SIZE_MB) {
//         oversizedFiles.push(file.name);
//       } else {
//         validFiles.push(file);
//       }
//     });

//     const errs = [];
//     if (unsupportedFiles.length > 0) {
//       errs.push(
//         `Unsupported format: ${unsupportedFiles.join(
//           ", "
//         )}. Allowed: ${SUPPORTED_LABEL}.`
//       );
//     }
//     if (oversizedFiles.length > 0) {
//       errs.push(
//         `The following files exceed ${MAX_FILE_SIZE_MB}MB: ${oversizedFiles.join(
//           ", "
//         )}`
//       );
//     }
//     if (errs.length > 0) {
//       setInlineError(errs.join(" "));
//     }

//     const combinedFiles = [...selectedFiles, ...validFiles];

//     if (combinedFiles.length > MAX_FILES) {
//       setPopup({
//         show: true,
//         type: "failed",
//         message: `You can upload a maximum of ${MAX_FILES} files at a time.`,
//         onConfirm: null,
//       });
//       return;
//     }

//     // Remove duplicates
//     const uniqueFiles = combinedFiles.filter(
//       (file, index, self) =>
//         index === self.findIndex((f) => f.name === file.name)
//     );

//     setSelectedFiles(uniqueFiles);
//   };

//   const handleRemoveFile = (fileName) => {
//     const filtered = selectedFiles.filter((file) => file.name !== fileName);
//     setSelectedFiles(filtered);
//   };

//   // const handleSubmit = async () => {
//   //   if (!knowledgeBaseId || selectedFiles.length === 0) {
//   //     setPopup({
//   //       show: true,
//   //       type: "failed",
//   //       message: "Please select files",
//   //       onConfirm: null,
//   //     });
//   //     return;
//   //   }

//   //   try {
//   //     setIsModalDisabled(true); // disable modal

//   //     setCancelButtonHeading(true);
//   //     submitSetLoading(true);
//   //     // Step 1: Upload files to the server
//   //     const uploadResponse = await uploadAgentFiles(agent_id, selectedFiles);

//   //     if (
//   //       !uploadResponse ||
//   //       !uploadResponse.files ||
//   //       uploadResponse.files.length === 0
//   //     ) {
//   //       setPopup({
//   //         show: true,
//   //         type: "failed",
//   //         message: "Failed to upload files to the server.",
//   //         onConfirm: null,
//   //       });
//   //       return;
//   //     }

//   //     const newServerFileNames = uploadResponse.files.map(
//   //       (file) => file.filename
//   //     );
//   //     localStorage.setItem(
//   //       "newlyUploadedFiles",
//   //       JSON.stringify(newServerFileNames)
//   //     );

//   //     // Step 2: Fetch server files
//   //     const serverFilesResponse = await getAgentFiles(agent_id);
//   //     const serverFiles = serverFilesResponse.files;

//   //     if (!serverFiles || serverFiles.length === 0) {
//   //       setPopup({
//   //         show: true,
//   //         type: "failed",
//   //         message: "Failed to retrieve files from the server.",
//   //         onConfirm: null,
//   //       });
//   //       localStorage.removeItem("newlyUploadedFiles");
//   //       return;
//   //     }

//   //     const storedFileNames = JSON.parse(
//   //       localStorage.getItem("newlyUploadedFiles") || "[]"
//   //     );
//   //     const filesForRetell = serverFiles.filter((serverFile) =>
//   //       storedFileNames.includes(serverFile.name)
//   //     );

//   //     if (filesForRetell.length === 0) {
//   //       setPopup({
//   //         show: true,
//   //         type: "failed",
//   //         message: "No matching files found on the server to upload to Retell.",
//   //         onConfirm: null,
//   //       });
//   //       localStorage.removeItem("newlyUploadedFiles");
//   //       return;
//   //     }

//   //     // Step 3: Prepare formData for Retell
//   //     const formData = new FormData();
//   //     filesForRetell.forEach((file) => {
//   //       const byteCharacters = atob(file.data);
//   //       const byteNumbers = new Array(byteCharacters.length);
//   //       for (let i = 0; i < byteCharacters.length; i++) {
//   //         byteNumbers[i] = byteCharacters.charCodeAt(i);
//   //       }
//   //       const byteArray = new Uint8Array(byteNumbers);
//   //       const blob = new Blob([byteArray], {
//   //         type: "application/octet-stream",
//   //       });
//   //       const fileToUpload = new File([blob], file.name);

//   //       formData.append("knowledge_base_files", fileToUpload);
//   //       formData.append("filename", fileToUpload.name);
//   //     });

//   //     // Step 4: Upload to Retell
//   //     const retellResponse = await addKnowledgeBaseSources(
//   //       token,
//   //       knowledgeBaseId,
//   //       formData,
//   //       agent_id
//   //     );

//   //     if (retellResponse?.success) {
//   //       setShowModal(false); // Close the modal
//   //       setSelectedFiles([]); // Clear selected files

//   //       setPopup({
//   //         show: true,
//   //         type: "success",
//   //         message: "Files uploaded successfully!",
//   //         onConfirm: () => {
//   //           fetchKnowledgeBaseDetails();
//   //           closePopup();
//   //         },
//   //       });
//   //       startPollingStatus(knowledgeBaseId);
//   //       setTimeout(() => {
//   //         setPopup({
//   //           show: false,
//   //         });
//   //       }, 2000);
//   //     } else {
//   //       console.error("Upload failed with status:", retellResponse.status);
//   //       setPopup({
//   //         show: true,
//   //         type: "failed",
//   //         message: "Upload failed.",
//   //         onConfirm: null,
//   //       });
//   //     }
//   //     submitSetLoading(false);
//   //   } catch (error) {
//   //     submitSetLoading(false);
//   //     setCancelButtonHeading(false);
//   //     console.error("Error during upload:", error);
//   //     setPopup({
//   //       show: true,
//   //       type: "failed",
//   //       message: "Upload failed.",
//   //       onConfirm: null,
//   //     });
//   //   } finally {
//   //     setCancelButtonHeading(false);
//   //     setIsModalDisabled(false);
//   //     submitSetLoading(false);
//   //     localStorage.removeItem("newlyUploadedFiles");
//   //   }
//   // };
//   const handleSubmit = async () => {
//     if (selectedFiles.length === 0) {
//       setPopup({ show: true, type: "failed", message: "Please select files", onConfirm: null });
//       return;
//     }

//     // Submit par dobara check — `accept` attribute sirf file dialog filter karta
//     // hai, use bypass karna aasan hai. Yahan se aage sirf allowed formats jaate hain.
//     const blocked = selectedFiles.filter(
//       (file) => !isAllowedFile(file?.name)
//     );
//     if (blocked.length > 0) {
//       setInlineError(
//         `Unsupported format: ${blocked
//           .map((f) => f.name)
//           .join(", ")}. Allowed: ${SUPPORTED_LABEL}.`
//       );
//       setSelectedFiles((prev) => prev.filter((f) => isAllowedFile(f?.name)));
//       return;
//     }

//     try {
//       setIsModalDisabled(true);
//       setCancelButtonHeading(true);
//       submitSetLoading(true);

//       // Step 1: Upload files to server
//       const uploadResponse = await uploadAgentFiles(agent_id, selectedFiles);
//       if (!uploadResponse?.files?.length) {
//         setPopup({ show: true, type: "failed", message: "Failed to upload files to the server.", onConfirm: null });
//         return;
//       }

//       const newServerFileNames = uploadResponse.files.map((file) => file.filename);
//       localStorage.setItem("newlyUploadedFiles", JSON.stringify(newServerFileNames));

//       // Step 2: Fetch server files
//       const serverFilesResponse = await getAgentFiles(agent_id);
//       const serverFiles = serverFilesResponse.files;
//       if (!serverFiles?.length) {
//         setPopup({ show: true, type: "failed", message: "Failed to retrieve files from the server.", onConfirm: null });
//         localStorage.removeItem("newlyUploadedFiles");
//         return;
//       }

//       const storedFileNames = JSON.parse(localStorage.getItem("newlyUploadedFiles") || "[]");
//       const filesForRetell = serverFiles.filter((serverFile) =>
//         storedFileNames.includes(serverFile.name)
//       );

//       if (!filesForRetell.length) {
//         setPopup({ show: true, type: "failed", message: "No matching files found on the server.", onConfirm: null });
//         localStorage.removeItem("newlyUploadedFiles");
//         return;
//       }

//       // Step 3: Prepare formData
//       const formData = new FormData();
//       filesForRetell.forEach((file) => {
//         const byteCharacters = atob(file.data);
//         const byteNumbers = new Array(byteCharacters.length);
//         for (let i = 0; i < byteCharacters.length; i++) {
//           byteNumbers[i] = byteCharacters.charCodeAt(i);
//         }
//         const byteArray = new Uint8Array(byteNumbers);
//         // Sahi content-type zaroori hai: octet-stream par Retell source to bana
//         // deta hai par text extract nahi karta — file dikhti hai, data khaali.
//         const contentType = guessMimeType(file.name, file.mimetype);
//         const blob = new Blob([byteArray], { type: contentType });
//         const fileToUpload = new File([blob], file.name, { type: contentType });
//         formData.append("knowledge_base_files", fileToUpload);
//         formData.append("filename", fileToUpload.name);
//       });

//       // Step 4: Upload to Retell (pass current knowledgeBaseId — could be null/old)
//       const retellResponse = await addKnowledgeBaseSources(
//         token,
//         knowledgeBaseId,   // could be old or null
//         formData,
//         agent_id
//       );

//       if (retellResponse?.success) {
//         // ✅ KEY FIX: If backend created a new KB, update state with new KB ID
//         const activeKbId =
//           retellResponse.newKnowledgeBaseId ||  // new KB was created
//           retellResponse.knowledgeBaseId ||      // existing KB was used
//           knowledgeBaseId;                       // fallback to current

//         setShowModal(false);
//         setSelectedFiles([]);

//         if (activeKbId && activeKbId !== knowledgeBaseId) {
//           // Naya KB bana — id badalne par useEffect khud refetch kar dega.
//           console.log("[KB] New KB ID received, updating state:", activeKbId);
//           setKnowledgeBaseId(activeKbId);
//         } else {
//           // KB id wahi hai, isliye useEffect trigger nahi hoga — list khud
//           // refresh karni padegi, warna user ko manually refresh karna padta hai.
//           await fetchKnowledgeBaseDetails(activeKbId);
//         }

//         setPopup({
//           show: true,
//           type: "success",
//           message: "Files uploaded successfully ! Please wait for 10-15 seconds for indexing to complete,Then refresh the page.",
//           onConfirm: closePopup,
//         });

//         // Retell file ko background mein index karta hai, isliye source turant
//         // list mein na aaye to polling use pakad legi.
//         startPollingStatus(activeKbId);

//         setTimeout(() => setPopup({ show: false }), 2000);
//       } else {
//         setPopup({ show: true, type: "failed", message: "Upload failed.", onConfirm: null });
//       }

//     } catch (error) {
//       console.error("Error during upload:", error);
//       setPopup({ show: true, type: "failed", message: "Upload failed.", onConfirm: null });
//     } finally {
//       setCancelButtonHeading(false);
//       setIsModalDisabled(false);
//       submitSetLoading(false);
//       localStorage.removeItem("newlyUploadedFiles");
//     }
//   };
//   const performDelete = async (sourceId) => {
//     const fileToDelete = knowledgeBaseSources.find(
//       (source) => source.source_id === sourceId
//     );
//     if (!fileToDelete) {
//       setPopup({
//         show: true,
//         type: "failed",
//         message: "Could not find file to delete.",
//         onConfirm: null,
//       });
//       return;
//     }
//     const filename = fileToDelete.filename;
//     try {
//       await deleteKnowledgeBaseSource(token, knowledgeBaseId, sourceId);
//       setKnowledgeBaseSources((prevSources) =>
//         prevSources.filter((source) => source.source_id !== sourceId)
//       );
//       const localServerResponse = await deleteAgentFile(agent_id, filename);
//       setPopup({
//         show: true,
//         type: "success",
//         message: "File deleted successfully!",
//         onConfirm: () => {
//           closePopup();
//         },
//       });
//     } catch (error) {
//       console.error("Delete failed:", error);
//       setPopup({
//         show: true,
//         type: "failed",
//         message: "Delete failed",
//         onConfirm: null,
//       });
//     }
//   };

//   const handleDeleteSource = (sourceId) => {
//     setPopup({
//       show: true,
//       type: "confirm",
//       message: "Are you sure you want to delete this file?",
//       onConfirm: () => performDelete(sourceId),
//     });
//   };

//   return (
//     <div className={styles.containerBox}>
//       <div className={styles.container}>
//         <div className={styles.Forsticky}>
//           <HeaderBar title="Knowledge Files" />
//         </div>
//         <br />
//         <div onClick={() => setShowModal(true)} className={styles.addButton}>
//           <img src="/svg/Add-icon.svg" />
//         </div>
//         <div className={styles.fileListHeader}>
//           {loading ? (
//             <Loader2 />
//           ) : (
//             (() => {
//               // Sirf file-type sources dikhao (URL/text sources ka filename nahi hota).
//               // Pehle yahan filename mein ek localStorage-based "KB-XXXX" code bhi
//               // match hota tha, jiski wajah se onboarding se aayi files aur
//               // storage clear hone ke baad ki saari files "No data" ban jaati thi.
//               const fileSources = knowledgeBaseSources.filter(
//                 (source) => source?.filename
//               );

//               return fileSources.length > 0 ? (
//                 fileSources.map((source) => (
//                   <li key={source.source_id} className={styles.uploadedFileItem}>
//                     <div className={styles.uploadedFileName}>
//                       <span title={source.filename}>{source.filename}</span>
//                     </div>
//                     <div className={styles.fileActions}>
//                       <a
//                         href={source.file_url}
//                         download
//                         className={styles.iconButton}
//                         title="Download"
//                       >
//                         <img
//                           src="/svg/download-invoice.svg"
//                           alt="download-invoice"
//                         />
//                       </a>
//                       <button
//                         className={styles.iconButton}
//                         title="Delete"
//                         onClick={() => handleDeleteSource(source.source_id)}
//                       >
//                         <img src="/svg/delete-invoice.svg" alt="delete-invoice" />
//                       </button>
//                     </div>
//                   </li>
//                 ))
//               ) : (
//                 <p className={styles.noData}>No data</p>
//               );
//             })()
//           )}
//         </div>

//         {showModal && (
//           <div className={styles.modalOverlay}>
//             <div
//               className={`${styles.modalContent} ${isModalDisabled ? styles.disabled : ""
//                 }`}
//             >
//               <h2 className={styles.modalTitle}>Upload Files (Max 1)</h2>
//               <hr />

//               <div className={styles.uploadGuidelines}>
//                 <p className={styles.capsul}> Supported Files</p>
//                 <p>
//                   {SUPPORTED_LABEL}
//                   <br />
//                 </p>{" "}
//               </div>

//               <p className={styles.suportfile}>
//                 {" "}
//                 For <b>CSV, XLS, and XLSX</b> files specifically, there are
//                 additional limits of
//                 <b> 1,000 rows</b> and <b>50 columns</b>.
//                 <br />
//               </p>

//               <input
//                 id="file-upload"
//                 type="file"
//                 multiple
//                 onChange={handleFileChange}
//                 className={styles.fileInput}
//                 accept={ACCEPT_ATTR}
//               />
//               <p className={styles.maxlimit}>
//                 Maximum file size limit: <b>10MB</b>.
//               </p>
//               {inlineError && <p className={styles.inlineError}>{inlineError}</p>}
//               <ul className={styles.selectedFileList}>
//                 {selectedFiles.map((file, index) => (
//                   <li key={index} className={styles.fileItem}>
//                     <span>{file.name}</span>
//                     <button
//                       type="button"
//                       className={styles.removeFileButton}
//                       onClick={() => handleRemoveFile(file.name)}
//                     >
//                       &times;
//                     </button>
//                   </li>
//                 ))}
//               </ul>
//               <div className={styles.modalActions}>
//                 <button
//                   onClick={() => {
//                     setShowModal(false);
//                     setSelectedFiles([]);
//                   }}
//                   disabled={cancelButtonHeading}
//                   className={styles.cancelButton}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleSubmit}
//                   className={styles.submitButton}
//                   disabled={selectedFiles.length === 0}
//                 >
//                   {submitLoading ? (
//                     <div style={{ display: "flex" }}>
//                       <Loader size={16} />
//                       &nbsp; Submitting
//                     </div>
//                   ) : (
//                     "Submit"
//                   )}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* The PopUp component is rendered here */}
//         {popup.show && (
//           <PopUp
//             type={popup.type}
//             message={popup.message}
//             onClose={closePopup}
//             onConfirm={popup.onConfirm}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default Fileinfo;


import React, { useEffect, useMemo, useState,useRef } from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
// import DesktopShell from "../../DesktopShell/DesktopShell";
// import { buildSidebarItems } from "../../DesktopShell/navItems";
import axios from "axios";
import HeaderBar from "../../HeaderBar/HeaderBar";
import AnimatedButton from "../../AnimatedButton/AnimatedButton";
import styles from "./Fileinfo.module.css";
import { FiDownload, FiTrash2 } from "react-icons/fi";
import {
  addKnowledgeBaseSources,
  deleteAgentFile,
  deleteKnowledgeBase,
  deleteKnowledgeBaseSource,
  getAgentById,
  getAgentFiles,
  getKnowledgeBase,
  listSiteMap,
  updateAgentKnowledgeBaseId,
  updateAgentFromBackend,
  uploadAgentFiles,
} from "../../../Store/apiStore";
// new
import PopUp from "../../Popup/Popup";
import { isPythonBackend, authHeaders } from "../../../utils/apiBackend";

import Loader from "../../Loader/Loader";
import Loader2 from "../../Loader2/Loader2";

// Allow multiple files per upload. Backend route accepts up to 10
// (upload.array("additional_file", 10)), so cap here to match.
const MAX_FILES = 10;
// Retell accepts up to 100MB; backend multer sets no size limit, so this is the
// only gate. (Was 10MB in the old add-file section.)
const MAX_FILE_SIZE_MB = 10;
// KB upload formats — full list of what Retell accepts (matches Retell's own
// "Supported Files" popup). Backend multer sets NO type/size restriction, so
// this frontend list is the only gate. (Previous shorter list kept below.)
const ALLOWED_EXTENSIONS = ["csv","md","pdf","txt","xls","xlsx"];
// const ALLOWED_EXTENSIONS = ["pdf", "txt", "md", "csv", "xlsx", "xls", "json", "jpeg", "jpg", "png"];

// Recover a file's ORIGINAL base name by stripping the server-added
// "-<timestamp>-<rand>" suffix that multer adds on upload. The SAME document
// (e.g. "480d6678.txt") therefore matches its already-saved copy
// ("480d6678-1786559597361-194640566.txt"). Mirrors the backend baseNameOf in
// uploadAgentFiles so the modal never even stages a file that's already saved —
// this is what caused the confusing "6 rows for a moment, then 5" flash.
const fileBaseNameOf = (p) => {
  const name = String(p || "").split(/[\\/]/).pop();
  const dot = name.lastIndexOf(".");
  const ext = dot >= 0 ? name.slice(dot) : "";
  const stem = dot >= 0 ? name.slice(0, dot) : name;
  return (stem.replace(/-\d{10,}-\d+$/, "") + ext).toLowerCase();
};
const ACCEPT_ATTR = ALLOWED_EXTENSIONS.map((x) => "." + x).join(",");

const SUPPORTED_LABEL = ALLOWED_EXTENSIONS.map((x) => "." + x).join(", ");

const getExtension = (fileName) => {
  const name = String(fileName || "");
  const dot = name.lastIndexOf(".");
  // Bina extension ke naam ("report") ya dot se shuru hone wale (".env") reject.
  if (dot <= 0) return "";
  return name.slice(dot + 1).toLowerCase();
};

const isAllowedFile = (fileName) =>
  ALLOWED_EXTENSIONS.includes(getExtension(fileName));

// Backend get-agent-files har file ke liye "application/octet-stream" lautata hai,
// isliye extension se asli type nikalte hain — Retell isi ke basis par parse karta hai.
const MIME_BY_EXT = {
  pdf: "application/pdf",
  txt: "text/plain",
  md: "text/markdown",
  csv: "text/csv",
  tsv: "text/tab-separated-values",
  json: "application/json",
  xml: "application/xml",
  html: "text/html",
  rtf: "application/rtf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  odt: "application/vnd.oasis.opendocument.text",
  epub: "application/epub+zip",
  eml: "message/rfc822",
  msg: "application/vnd.ms-outlook",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  bmp: "image/bmp",
  tiff: "image/tiff",
  heic: "image/heic",
};

const guessMimeType = (fileName, fallback) => {
  const ext = (fileName?.split(".").pop() || "").toLowerCase();
  return (
    MIME_BY_EXT[ext] ||
    (fallback && fallback !== "application/octet-stream" ? fallback : null) ||
    "application/octet-stream"
  );
};
const Fileinfo = () => {

  const location = useLocation();
  const navigate = useNavigate();
  // Resolve the agent + KB ids resiliently. Navigation state is the primary
  // source, but it's sometimes empty (data not ready at click time, or state
  // lost on some transitions), which left the page stuck loading. agent_id
  // rarely changes, so we fall back to storage (the keys the app already sets).
  // knowledgeBaseId is NOT trusted from storage (it can be deleted/recreated) —
  // when it's missing from state we re-fetch the CURRENT one from the backend
  // by agent_id (see the useEffect below).
  const navState = location.state || {};
  // Resolve agent_id resiliently. Navigation state is primary. Fallbacks (in
  // order): the "agent_id" key, then "SelectAgentId" — which the agent-detail
  // flow reliably sets to the CURRENT agent's agent_id right before navigating
  // here (verified: AgentCardDetail sets SelectAgentId = agentData.agent.agent_id).
  // We intentionally do NOT use the camelCase "agentId" key — the calls-list
  // switcher writes a possibly-different agent there. Whatever id we resolve,
  // the KB id is then re-verified against the backend (getAgentById below), so a
  // slightly-off fallback can't silently show a stale KB.
  const agent_id =
    navState.agent_id ||
    sessionStorage.getItem("agent_id") ||
    localStorage.getItem("agent_id") ||
    sessionStorage.getItem("SelectAgentId") ||
    null;
  const initialKnowledgeBaseId = navState.knowledgeBaseId || null;
  const [knowledgeBaseSources, setKnowledgeBaseSources] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  // True while a KB operation (add crawl/ingest OR delete) is running. Drives a
  // "Processing…" banner so the user knows it takes time (like Retell's own
  // "Refreshing"). kbProcessingMsg holds the context-specific message.
  const [kbProcessing, setKbProcessing] = useState(false);
  const [kbProcessingMsg, setKbProcessingMsg] = useState("");
  const [submitLoading, submitSetLoading] = useState(false);
  const [cancelButtonHeading, setCancelButtonHeading] = useState(false);
  const [inlineError, setInlineError] = useState("");
  const [isModalDisabled, setIsModalDisabled] = useState(false);
  const token = localStorage.getItem("token");
  const [knowledgeBaseId, setKnowledgeBaseId] = useState(initialKnowledgeBaseId);

  // Polling interval ka handle — unmount/naye poll par clear karne ke liye.
  const pollRef = useRef(null);

  // ---- Display-only helpers (added to render ALL sources of this agent's KB,
  // like Retell). These do NOT change upload/stableCode/delete logic. ----

  // Which URL sources are expanded to reveal their scraped pages (keyed by source_id)
  const [expandedUrls, setExpandedUrls] = useState({});
  const toggleUrlExpand = (sourceId) =>
    setExpandedUrls((prev) => ({ ...prev, [sourceId]: !prev[sourceId] }));

  // Set of URLs already present in this KB (existing sources + not-yet-saved
  // pending ones). Used to prevent re-adding a duplicate web page: Retell does
  // NOT de-dupe, so re-selecting an already-added url would create a second
  // identical source. We compare trimmed strings.
  const existingKbUrlSet = useMemo(() => {
    const set = new Set();
    (Array.isArray(knowledgeBaseSources) ? knowledgeBaseSources : []).forEach(
      (s) => {
        if (s?.type === "url" && s?.url) set.add(String(s.url).trim());
      }
    );
    return set;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [knowledgeBaseSources]);

  // Human-readable size, matching Retell's style ("0 K", "12 K", "1.2 M")
  const formatSize = (bytes) => {
    const n = Number(bytes) || 0;
    if (n < 1024) return `${n} B`;
    if (n < 1024 * 1024) return `${Math.round(n / 1024)} K`;
    return `${(n / (1024 * 1024)).toFixed(1)} M`;
  };

  // The text/file download link (Retell returns it as content_url or file_url).
  const getDownloadUrl = (source) =>
    source.content_url || source.file_url || source.url || null;

  // Python text sources are protected by JWT authentication. A regular <a>
  // navigation cannot attach the Authorization header, which resulted in the
  // browser showing {"detail":"Missing bearer token"}. Fetch the text with the
  // same authenticated headers used by upload/list requests, then download the
  // returned blob locally. Retell and ordinary file URLs keep their existing
  // direct-download behaviour.
  const downloadPythonText = async (event, source, filename) => {
    event.preventDefault();
    const url = getDownloadUrl(source);
    if (!url) return;
    try {
      const response = await fetch(url, { headers: authHeaders() });
      if (!response.ok) throw new Error(`Download failed (${response.status})`);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = `${filename}.txt`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error("Failed to download Python knowledge-base text:", error);
      setPopup({
        show: true,
        type: "failed",
        message: "Could not download this text. Please try again.",
        onConfirm: null,
      });
    }
  };

  // Retell returns EACH scraped page as its own { type:"url", url } source, and
  // its dashboard groups them by the FULL hostname — so www.foo.com and
  // sub.foo.com become two separate cards. We match that exactly. Text/files as-is.
  const groupSources = (sources) => {
    const urlGroups = {}; // hostname -> { host, pages:[{source_id,url}] }
    const others = []; // text + document sources, in original order

    (Array.isArray(sources) ? sources : []).forEach((s) => {
      if (s.type === "url" && s.url) {
        let host = s.url;
        try {
          host = new URL(s.url).hostname; // full hostname, keep subdomain (like Retell)
        } catch (_) {}
        if (!urlGroups[host]) urlGroups[host] = { host, pages: [] };
        urlGroups[host].pages.push({ source_id: s.source_id, url: s.url });
      } else {
        others.push(s);
      }
    });

    return { urlGroups: Object.values(urlGroups), others };
  };

  // Restore the agent's knowledge base from the saved DB business data WITHOUT
  // the user having to edit business details. Hits the same updateAgent flow
  // that rebuilds the KB (business text + scrapedUrls + knowledge_base_urls +
  // manual text + files), but with forceKbRebuild:true so it runs even though no
  // field changed. On success we pick up the new KB id and refresh the list.
  const handleRestoreKnowledgeBase = async () => {
    // No confirm popup — restore directly on click.
    if (!agent_id) {
      setInlineError("Could not find the agent to restore. Please reload.");
      return;
    }

    // Python agent: rebuild the agent's Qdrant KB from the DB sources that are
    // NEVER deleted — knowledge_base_texts (Business Details) + scrapedUrls. This
    // hits POST /py/agents/{id}/kb/rebuild, whose background task reads those
    // stored sources (kb_source.load_chunks_for_agent + the stored scrapedUrls)
    // and re-embeds them. There is no knowledgeBaseId to juggle: the KB is the
    // agent's own collection. On completion we refresh the list so the Business
    // Details + URL cards reappear, exactly like Retell's Restore.
    if (isPythonBackend()) {
      try {
        setKbProcessingMsg(
          "Restoring your knowledge base from your business details… This can take a moment."
        );
        setKbProcessing(true);
        const base = process.env.REACT_APP_PY_API_BASE_URL;
        const resp = await fetch(`${base}/agents/${agent_id}/kb/rebuild`, {
          method: "POST",
          headers: { ...authHeaders(), "Content-Type": "application/json" },
          body: JSON.stringify({}),
        });
        if (!resp.ok) {
          const err = await resp.json().catch(() => ({}));
          throw new Error(err.detail || "Restore failed");
        }
        // The rebuild runs in the background; the source LIST (which we display)
        // comes straight from the DB, so it is already correct immediately — no
        // need to poll Qdrant indexing before showing the cards.
        await fetchKnowledgeBaseDetails();
      } catch (e) {
        console.error("Python restore KB failed:", e);
        setInlineError(
          "Could not restore the knowledge base. Please try again."
        );
      } finally {
        setKbProcessing(false);
      }
      return;
    }

    try {
      setKbProcessingMsg(
        "Restoring your knowledge base from your business details… This can take a moment."
      );
      setKbProcessing(true);
      const resp = await updateAgentFromBackend({
        agent_id,
        forceKbRebuild: true,
      });
      // updateAgent rebuilds the KB and saves the new id to the agent. Pick up
      // the fresh id from the backend so the page loads the restored KB.
      const freshRes = await getAgentById(agent_id);
      const freshKbId =
        freshRes?.data?.agent?.knowledgeBaseId ||
        freshRes?.data?.knowledgeBaseId ||
        null;
      if (freshKbId) {
        setKnowledgeBaseId(freshKbId);
        sessionStorage.setItem("knowledgeBaseId", freshKbId);
        localStorage.setItem("knowledgeBaseId", freshKbId);
        await waitForKbReady(freshKbId);
        await fetchKnowledgeBaseDetails(freshKbId);
      } else {
        setKbProcessing(false);
      }
    } catch (e) {
      console.error("Restore KB failed:", e);
      setKbProcessing(false);
      setInlineError("Could not restore the knowledge base. Please try again.");
    }
  };

  // =====================================================================
  //  EDIT KNOWLEDGE BASE modal (Retell-style) — Documents list + "+ Add"
  //  (Add Web Pages / Upload Files / Add Text). Applies changes to the
  //  agent's KB on Retell using the same endpoints the old edit flow used.
  // =====================================================================
  const [showEditModal, setShowEditModal] = useState(false);
  const [addMenuOpen, setAddMenuOpen] = useState(false);
  // The "+ Add" button element + computed screen position for the portal menu.
  // The menu is rendered via a portal to document.body so it can overflow the
  // modal (which has overflow:hidden) and float outside it, exactly like Retell.
  const addBtnRef = useRef(null);
  const [addMenuPos, setAddMenuPos] = useState({
    top: 0,
    left: 0,
    maxHeight: null,
    width: null,
  });
  // Synchronous re-entry lock for Save (prevents duplicate uploads on double-click).
  const savingRef = useRef(false);
  // Which sub-panel is open: null | "url" | "upload" | "text"
  const [addPanel, setAddPanel] = useState(null);
  const [editBusy, setEditBusy] = useState(false);
  // Hidden file input — clicking "Upload Files" opens the OS picker directly.
  const uploadInputRef = useRef(null);
  const openUploadPicker = () => {
    // Open the native file dialog FIRST (synchronously in the click gesture) so
    // there's no delay; then do the state resets.
    if (uploadInputRef.current) {
      uploadInputRef.current.value = ""; // allow re-selecting the same file
      uploadInputRef.current.click();
    }
    setAddMenuOpen(false);
    setSelectedFiles([]);
    setInlineError("");
  };

  // Toggle the "+ Add" menu. When opening, measure the button's on-screen box so
  // the portal menu can be placed just below it (and float outside the modal).
  const toggleAddMenu = () => {
    setAddMenuOpen((open) => {
      const next = !open;
      if (next && addBtnRef.current) {
        const r = addBtnRef.current.getBoundingClientRect();
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        const gap = 8; // space between button and menu
        const margin = 8; // keep this much clear of the viewport edges
        const menuW = Math.min(380, Math.max(0, vw - margin * 2));

        // Keep the menu on-screen horizontally: start at the button's left, but
        // pull it back if it would run off the right edge on a narrow screen.
        let left = r.left;
        if (left + menuW > vw - margin) left = vw - margin - menuW;
        if (left < margin) left = margin;

        // ALWAYS open downward (never flip upward — flipping up covered the
        // document list). Cap the height to the space available below the button
        // so on short screens the menu shrinks-to-fit and scrolls internally
        // instead of running off the bottom edge.
        const top = r.bottom + gap;
        const maxHeight = vh - top - margin;
        setAddMenuPos({ top, left, maxHeight, width: menuW });
      }
      return next;
    });
  };

  // Close the "+ Add" portal menu on outside-click / Escape / scroll / resize —
  // since it lives outside the modal, it needs its own dismissal wiring.
  useEffect(() => {
    if (!addMenuOpen) return undefined;
    // IMPORTANT: ignore clicks on the "+ Add" button itself, otherwise this
    // outside-click handler would close the menu just before the button's
    // onClick re-opens it — so a second click never toggled it shut. Let the
    // button's own toggleAddMenu handle its clicks; close only for elsewhere.
    const closeOnOutside = (e) => {
      if (addBtnRef.current && addBtnRef.current.contains(e.target)) return;
      setAddMenuOpen(false);
    };
    const onScrollResize = () => setAddMenuOpen(false);
    const onKey = (e) => {
      if (e.key === "Escape") setAddMenuOpen(false);
    };
    // Delay attaching so the opening click doesn't immediately self-close.
    const t = setTimeout(() => {
      document.addEventListener("mousedown", closeOnOutside);
    }, 0);
    window.addEventListener("scroll", onScrollResize, true);
    window.addEventListener("resize", onScrollResize);
    document.addEventListener("keydown", onKey);
    return () => {
      clearTimeout(t);
      document.removeEventListener("mousedown", closeOnOutside);
      window.removeEventListener("scroll", onScrollResize, true);
      window.removeEventListener("resize", onScrollResize);
      document.removeEventListener("keydown", onKey);
    };
  }, [addMenuOpen]);

  // Add Text sub-flow
  const [textName, setTextName] = useState("");
  const [textContent, setTextContent] = useState("");
  // Texts staged (shown as pending rows) but not uploaded until main Save.
  const [pendingTexts, setPendingTexts] = useState([]); // [{ title, text }]
  // Source_ids marked for deletion (hidden from the list) — applied on Save.
  const [pendingDeletes, setPendingDeletes] = useState([]); // [source_id, ...]
  // Web-page URLs staged (shown as one pending URL row) — applied on Save.
  const [pendingUrls, setPendingUrls] = useState([]); // [ "https://..." ]

  // Add Web Pages sub-flow
  const [urlInput, setUrlInput] = useState("");
  const [sitemapLoading, setSitemapLoading] = useState(false);
  const [sitemapUrls, setSitemapUrls] = useState(null); // null = picker not shown yet
  const [selectedSiteUrls, setSelectedSiteUrls] = useState({});
  const [siteSearch, setSiteSearch] = useState("");

  const openEditModal = () => {
    setShowEditModal(true);
    setAddMenuOpen(false);
    setAddPanel(null);
    setPendingTexts([]);
    setSelectedFiles([]);
    setPendingDeletes([]);
    setPendingUrls([]);
    resetAddPanels();
    // Sync the modal's source list with Retell SILENTLY (no loading flicker):
    // fetch the current sources but don't toggle the page `loading` state, so
    // the modal opens instantly with the freshest data. This prevents showing a
    // stale/duplicate list vs. what's actually on Retell.
    refreshSourcesSilently();
  };

  // Fetch the KB's current sources WITHOUT flipping `loading` (so no dots flash).
  const refreshSourcesSilently = async () => {
    const kbId = knowledgeBaseId;
    if (!kbId) return;
    try {
      const response = await getKnowledgeBase(token, kbId);
      setKnowledgeBaseSources(response.data?.knowledge_base_sources || []);
    } catch (_) {
      /* keep whatever we already have */
    }
  };

  const resetAddPanels = () => {
    setTextName("");
    setTextContent("");
    setUrlInput("");
    setSitemapUrls(null);
    setSelectedSiteUrls({});
    setSiteSearch("");
    setSitemapLoading(false);
  };

  const closeEditModal = () => {
    // Always allow closing — even while a save is running. The add/delete work
    // continues in the background (the "Processing…" banner keeps the user
    // informed) so they can close the modal and do other things meanwhile.
    setShowEditModal(false);
    setAddMenuOpen(false);
    setAddPanel(null);
    // Only clear the staged/pending data when NOTHING is in flight. If a save is
    // still running it's mid-way through these lists, so leave them intact.
    if (!editBusy) {
      setPendingTexts([]);
      setSelectedFiles([]);
      setPendingDeletes([]);
      setPendingUrls([]);
      resetAddPanels();
    }
  };

  // ---- Delete: just STAGE the source_id (no popup). Applied on main Save. ----
  const editDeleteSource = (source) => {
    setPendingDeletes((prev) =>
      prev.includes(source.source_id) ? prev : [...prev, source.source_id]
    );
  };

  // ---- Delete a whole URL domain group: stage its real page source_ids, and
  //      drop any pending (not-yet-saved) URLs that belong to this group. ----
  const editDeleteUrlGroup = (group) => {
    const realIds = group.pages
      .map((p) => p.source_id)
      .filter((id) => !String(id).startsWith("__pendingurl_"));
    if (realIds.length) {
      setPendingDeletes((prev) => [
        ...prev,
        ...realIds.filter((id) => !prev.includes(id)),
      ]);
    }
    // Remove pending URLs whose hostname matches this group.
    setPendingUrls((prev) =>
      prev.filter((u) => {
        let host = u;
        try {
          host = new URL(u).hostname;
        } catch (_) {}
        return host !== group.host;
      })
    );
  };

  // ---- Add Text: STAGE it as a pending row (upload happens on main Save) ----
  const stageAddText = () => {
    if (!textName.trim() || !textContent.trim()) return; // silently ignore empty
    setPendingTexts((prev) => [
      ...prev,
      { title: textName.trim(), text: textContent.trim() },
    ]);
    setAddPanel(null);
    setTextName("");
    setTextContent("");
  };

  // Silently upload staged files to Retell (no popups). Mirrors handleSubmit's
  // core steps: server upload -> fetch -> add to KB. Accepts the active KB id
  // (which may be null → backend creates a new KB) and reports any new id back
  // via captureKbId. Returns the (possibly new) active KB id.
  const uploadPendingFilesSilent = async (kbId, captureKbId) => {
    if (selectedFiles.length === 0) return kbId;

    // De-dupe within THIS batch by file name (same file picked twice in one
    // selection shouldn't upload twice).
    const seen = new Set();
    const uniqueSelected = selectedFiles.filter((f) => {
      const key = `${f?.name}::${f?.size}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
    if (uniqueSelected.length === 0) return kbId;

    // Python agent: send the WHOLE selection in ONE multipart request to
    // POST /py/agents/{id}/files (which now accepts a `files` array, validates
    // size/extension server-side, and rebuilds the Qdrant KB ONCE for the batch
    // — matching Retell's single upload.array request). No Retell KB id.
    if (isPythonBackend()) {
      const base = process.env.REACT_APP_PY_API_BASE_URL;
      const fd = new FormData();
      uniqueSelected.forEach((f) => fd.append("files", f, f.name));
      // Strip Content-Type so the browser sets the multipart boundary.
      const { "Content-Type": _ct, ...uploadHeaders } = authHeaders();
      const r = await fetch(`${base}/agents/${agent_id}/files`, {
        method: "POST",
        headers: uploadHeaders,
        body: fd,
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.detail || "File upload failed");
      }
      return kbId; // Python has no Retell KB id to capture.
    }

    const uploadResponse = await uploadAgentFiles(agent_id, uniqueSelected);
    if (!uploadResponse?.files?.length) throw new Error("Server upload failed");

    const newNames = uploadResponse.files.map((f) => f.filename);
    const serverFilesResponse = await getAgentFiles(agent_id);
    const serverFiles = serverFilesResponse.files || [];
    const filesForRetell = serverFiles.filter((sf) => newNames.includes(sf.name));
    if (!filesForRetell.length) throw new Error("No matching server files");

    const formData = new FormData();
    filesForRetell.forEach((file) => {
      const byteCharacters = atob(file.data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const blob = new Blob([new Uint8Array(byteNumbers)], {
        type: "application/octet-stream",
      });
      const fileToUpload = new File([blob], file.name);
      formData.append("knowledge_base_files", fileToUpload);
      formData.append("filename", fileToUpload.name);
    });

    const resp = await addKnowledgeBaseSources(token, kbId, formData, agent_id);
    if (resp?.success === false) throw new Error(resp?.message);
    if (captureKbId) captureKbId(resp);
    return resp?.newKnowledgeBaseId || resp?.knowledgeBaseId || kbId;
  };

  // Apply ALL staged changes (deletes + texts + urls + files) silently, then
  // refresh. Called by the main Save. No popups anywhere.
  const applyAllChanges = async () => {
    // Show the processing banner with a message that matches what's actually
    // happening (delete sources vs add web pages vs add text/files), so the
    // wording never implies more than it does.
    const isDeleting = pendingDeletes.length > 0;
    const hasUrls = pendingUrls.length > 0;
    const hasOtherAdds = pendingTexts.length + selectedFiles.length > 0;
    let msg;
    if (hasUrls) {
      // Web-page crawl is the only thing that can take minutes.
      msg =
        "Adding web pages… Large websites can take a few minutes to process. You can keep working — it will update automatically.";
    } else if (hasOtherAdds && isDeleting) {
      msg =
        "Updating your knowledge base… You can keep working — it will update automatically.";
    } else if (hasOtherAdds) {
      msg =
        "Adding to your knowledge base… You can keep working — it will update automatically.";
    } else {
      // Delete-only of sources (NOT the whole KB).
      msg =
        "Removing the selected sources… You can keep working — it will update automatically.";
    }
    setKbProcessingMsg(msg);
    setKbProcessing(true);

    // Helper to delete ONE source (Retell + DB mirror). The actual delete loop
    // runs LATER (step 4), AFTER adds, so removing the last old source never
    // trips Retell's "cannot delete the last source" error.
    const deleteOne = async (sourceId) => {
      const src = knowledgeBaseSources.find((s) => s.source_id === sourceId);

      // ── PYTHON: one delete endpoint handles every source type ──────────────
      // POST /py/agents/{id}/kb/sources/delete removes the item from its DB
      // column (knowledge_base_urls + scrapedUrls for a URL, knowledge_base_files
      // for a text, AgentDetails.files + storage for a file) and rebuilds the
      // agent's Qdrant collection WITHOUT it — so the agent forgets the deleted
      // content immediately. knowledge_base_texts (Business Details) is preserved
      // for Restore, exactly like Retell. We match by CONTENT (url / title), not
      // the source_id index, because the rebuild re-numbers sources. No separate
      // file-delete call — the endpoint cleans up storage itself.
      if (isPythonBackend()) {
        const base = process.env.REACT_APP_PY_API_BASE_URL;
        const payload = { source_id: sourceId };
        if (src?.type === "url" && src.url) payload.url = src.url;
        else if (src?.type === "text")
          payload.textTitle = src.title || src.name || "";
        try {
          const r = await fetch(`${base}/agents/${agent_id}/kb/sources/delete`, {
            method: "POST",
            headers: { "Content-Type": "application/json", ...authHeaders() },
            body: JSON.stringify(payload),
          });
          return r.ok;
        } catch (_) {
          return false;
        }
      }

      // ── RETELL: delete from Retell KB + DB mirror (unchanged) ──────────────
      // Pass sync info to the SAME delete call so the backend removes the item
      // from Retell AND from our DB mirror in one shot (no extra endpoint):
      //   • web page  → { agentId, url }        → knowledge_base_urls
      //   • manual text → { agentId, textTitle } → knowledge_base_files
      // Retell only exposes a text source's title (body is behind content_url),
      // so we match manual texts by title, which is what the user names them.
      let syncInfo = {};
      if (src?.type === "url" && src.url && agent_id) {
        syncInfo = { agentId: agent_id, url: src.url };
      } else if (src?.type === "text" && agent_id) {
        syncInfo = {
          agentId: agent_id,
          textTitle: src.title || src.name || "",
        };
      }
      const resp = await deleteKnowledgeBaseSource(
        token,
        // Delete from the CURRENT active KB. In the normal case this equals
        // knowledgeBaseId; if adds just created a fresh KB, activeKbId points
        // there — but the old source_ids belong to the previous KB, so this
        // only matters as a guard. deleteOne is always called after activeKbId
        // is set, so the closure sees the up-to-date value.
        activeKbId || knowledgeBaseId,
        sourceId,
        syncInfo
      );
      const ok = resp?.success !== false;
      if (ok) {
        // Uploaded file → remove from server + AgentDetails.files (existing flow).
        if (src?.type === "document" && src.filename) {
          try {
            await deleteAgentFile(agent_id, src.filename);
          } catch (_) {}
        }
      }
      return ok;
    };

    // Track the active KB id. If the KB was deleted (id is null) OR Retell no
    // longer has it, the backend CREATES a fresh KB on the first add and returns
    // `newKnowledgeBaseId`. We capture it and use it for every following call.
    let activeKbId = knowledgeBaseId;
    const captureKbId = (resp) => {
      const created = resp?.newKnowledgeBaseId || resp?.knowledgeBaseId;
      if (created && created !== activeKbId) {
        activeKbId = created;
        setKnowledgeBaseId(created); // so the rest of the page uses the new KB
        // Keep storage fresh so navigating away/back uses the NEW KB id.
        sessionStorage.setItem("knowledgeBaseId", created);
        localStorage.setItem("knowledgeBaseId", created);
      }
    };

    // ORDER MATTERS: we ADD new sources BEFORE deleting old ones. Retell forbids
    // deleting the LAST source of a KB ("cannot delete the last source"). If the
    // user removes every existing source AND adds a new one in the same Save,
    // deleting first would hit that error on the final delete. Adding first
    // guarantees the KB always has ≥1 source, so the subsequent deletes of the
    // old sources succeed. (The "delete everything, add nothing" case never
    // reaches here — handleEditSave routes it to the whole-KB-delete confirm.)

    // ── PYTHON: ONE combined add ───────────────────────────────────────────
    // A Python agent sends every staged add — texts + web pages + files — in a
    // SINGLE multipart request to POST /py/agents/{id}/kb/sources, which stores
    // each in its own column and rebuilds the Qdrant KB ONCE (not once per type).
    // This mirrors Retell's single add-knowledge-base-sources call. The
    // per-type Retell blocks below are skipped for Python.
    if (isPythonBackend()) {
      if (
        pendingTexts.length > 0 ||
        pendingUrls.length > 0 ||
        selectedFiles.length > 0
      ) {
        const base = process.env.REACT_APP_PY_API_BASE_URL;
        const fd = new FormData();
        if (pendingUrls.length > 0) fd.append("urls", JSON.stringify(pendingUrls));
        if (pendingTexts.length > 0)
          fd.append("texts", JSON.stringify(pendingTexts));
        // De-dupe files within this batch by name+size, then attach them all.
        const seen = new Set();
        selectedFiles
          .filter((f) => {
            const k = `${f?.name}::${f?.size}`;
            if (seen.has(k)) return false;
            seen.add(k);
            return true;
          })
          .forEach((f) => fd.append("files", f, f.name));
        // Strip Content-Type so the browser sets the multipart boundary.
        const { "Content-Type": _ct, ...uploadHeaders } = authHeaders();
        const r = await fetch(`${base}/agents/${agent_id}/kb/sources`, {
          method: "POST",
          headers: uploadHeaders,
          body: fd,
        });
        if (!r.ok) {
          const err = await r.json().catch(() => ({}));
          throw new Error(err.detail || "Failed to add sources");
        }
      }
    } else {
      // ── RETELL: per-type adds (unchanged) ────────────────────────────────
      // 1. Texts
      if (pendingTexts.length > 0) {
        const fd = new FormData();
        fd.append("knowledge_base_texts", JSON.stringify(pendingTexts));
        const resp = await addKnowledgeBaseSources(
          token,
          activeKbId,
          fd,
          agent_id
        );
        if (resp?.success === false) throw new Error(resp?.message);
        captureKbId(resp);
      }

      // 2. URLs (web pages)
      if (pendingUrls.length > 0) {
        const fd = new FormData();
        fd.append("knowledge_base_urls", JSON.stringify(pendingUrls));
        const resp = await addKnowledgeBaseSources(
          token,
          activeKbId,
          fd,
          agent_id
        );
        if (resp?.success === false) throw new Error(resp?.message);
        captureKbId(resp);
      }

      // 3. Files
      activeKbId = await uploadPendingFilesSilent(activeKbId, captureKbId);
    }

    // 4. Deletes — now that any new sources exist, deleting the old ones can
    //    never hit the "last source" error. Resilient: retry failures a few
    //    times (Retell can reject a delete while still ingesting an add).
    // Order matters for Python manual-text deletes: the backend removes a text
    // by its index in knowledge_base_files (text_manual_{i}). Deleting a LOWER
    // index first shifts every higher index down by one, so a later delete would
    // hit the wrong entry. Delete text_manual_{i} in DESCENDING index order so
    // earlier removals never invalidate later ones. Non-text sources (url_*,
    // file paths) are index-independent and keep their original order.
    const textIdx = (sid) => {
      const m = /^text_manual_(\d+)$/.exec(sid || "");
      return m ? parseInt(m[1], 10) : -1;
    };
    let toDelete = [...pendingDeletes].sort((a, b) => textIdx(b) - textIdx(a));
    for (let pass = 0; pass < 3 && toDelete.length > 0; pass++) {
      const failed = [];
      for (const sourceId of toDelete) {
        const ok = await deleteOne(sourceId);
        if (!ok) failed.push(sourceId);
      }
      toDelete = failed;
      if (toDelete.length > 0) {
        // brief wait before retrying the stragglers
        await new Promise((r) => setTimeout(r, 1500));
      }
    }

    // 5. Retell ingests new sources ASYNCHRONOUSLY — if we fetch right away the
    // new URLs/texts aren't there yet (that's why they only appeared after a
    // manual reload). Poll until the KB status is "complete" (or a few tries),
    // THEN refresh so the page shows them immediately.
    const added =
      pendingTexts.length + pendingUrls.length + selectedFiles.length;
    if (isPythonBackend()) {
      // Python: the source LIST comes straight from the DB (updated the moment
      // the add endpoint returned), so there is nothing to poll — the Qdrant
      // re-embed runs in the background but does not gate the display. Drop the
      // banner and refresh directly. waitForKbReady is Retell-only (no KB id).
      setKbProcessing(false);
    } else if (added > 0) {
      // waitForKbReady manages the banner until Retell finishes ingesting.
      await waitForKbReady(activeKbId);
    } else {
      // Delete-only — no async ingest to wait on, so drop the banner now.
      setKbProcessing(false);
    }
    await fetchKnowledgeBaseDetails(activeKbId);
  };

  // Poll the KB until Retell reports status "complete". Large sites (hundreds of
  // pages) can take minutes to crawl, so we poll for up to ~5 minutes and keep a
  // "Processing…" banner visible the whole time (like Retell's "Refreshing").
  const waitForKbReady = async (kbIdOverride) => {
    const kbId = kbIdOverride || knowledgeBaseId;
    if (!kbId) return;
    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
    setKbProcessing(true);
    // ~5 min: 60 polls × 5s. Statuses seen from Retell: "complete",
    // "in_progress", "refreshing_in_progress", "error".
    for (let i = 0; i < 60; i++) {
      try {
        const res = await getKnowledgeBase(token, kbId);
        const status = res?.data?.status;
        // Keep the latest sources visible as they trickle in.
        if (res?.data?.knowledge_base_sources) {
          setKnowledgeBaseSources(res.data.knowledge_base_sources);
        }
        if (!status || status === "complete" || status === "error") {
          setKbProcessing(false);
          return;
        }
      } catch (_) {
        setKbProcessing(false);
        return; // on error, stop waiting and just do the normal fetch
      }
      await sleep(5000);
    }
    setKbProcessing(false);
  };

  // Delete the ENTIRE knowledge base (Retell) and clear the agent's DB
  // reference. Used only when the user removes the very last source — Retell
  // forbids an empty KB ("cannot delete the last source, delete the knowledge
  // base instead").
  const deleteEntireKb = async () => {
    try {
      setEditBusy(true);
      setKbProcessingMsg(
        "Removing all sources… You can keep working — it will update automatically."
      );
      setKbProcessing(true);
      // 1. Delete on Retell
      await deleteKnowledgeBase(token, knowledgeBaseId);
      // 2. Clear the reference in our DB so the agent no longer points at a
      //    KB that no longer exists.
      if (agent_id) {
        try {
          await updateAgentKnowledgeBaseId(agent_id, null);
        } catch (_) {}
      }
      // 3. Clear local state + storage — the KB no longer exists, so no stale
      //    id should linger anywhere (the page now shows the empty state).
      setKnowledgeBaseSources([]);
      setKnowledgeBaseId(null);
      sessionStorage.removeItem("knowledgeBaseId");
      localStorage.removeItem("knowledgeBaseId");
    } catch (e) {
      console.error("Delete KB failed:", e);
      await fetchKnowledgeBaseDetails();
    } finally {
      setPendingTexts([]);
      setSelectedFiles([]);
      setPendingDeletes([]);
      setPendingUrls([]);
      resetAddPanels();
      setKbProcessing(false);
      setEditBusy(false);
      setShowEditModal(false);
    }
  };

  // Main Save. Figures out whether this Save would leave the KB with ZERO
  // sources (the user deleted everything / the last one). Only in that case do
  // we delete the whole KB (after a clear confirm). Any partial delete/add runs
  // the normal apply path — the KB is NEVER deleted on a normal source delete.
  const handleEditSave = async () => {
    // Guard against double-save: if a save is already running, ignore extra
    // clicks. Without this, clicking Save twice (or while ingesting) ran
    // applyAllChanges again and RE-UPLOADED the same files, creating duplicate
    // sources on Retell (e.g. the same file appearing 2–3 times). We use a ref
    // (updates synchronously) so two rapid clicks can't both slip past before
    // React's editBusy state has flushed.
    if (savingRef.current || editBusy) return;
    savingRef.current = true;

    const hasChanges =
      selectedFiles.length > 0 ||
      pendingTexts.length > 0 ||
      pendingUrls.length > 0 ||
      pendingDeletes.length > 0;
    if (!hasChanges) {
      savingRef.current = false;
      closeEditModal();
      return;
    }

    // How many sources will remain AFTER this save?
    const remainingExisting = knowledgeBaseSources.filter(
      (s) => !pendingDeletes.includes(s.source_id)
    ).length;
    const beingAdded =
      pendingTexts.length + pendingUrls.length + selectedFiles.length;
    const remainingAfterSave = remainingExisting + beingAdded;

    // Case: everything is being removed and nothing is being added → KB would be
    // empty. Retell FORBIDS an empty KB ("cannot delete the last source"), so it
    // needs the confirm + whole-KB delete. A PYTHON agent has no such rule — its
    // KB is the agent's own Qdrant collection (keyed by agent_id), which is fine
    // empty and is never unlinked/recreated. So for Python we DO NOT show the
    // popup and DO NOT delete the KB: we just apply the deletes through the normal
    // path (which rebuilds the Qdrant collection with whatever remains, i.e.
    // nothing). scrapedUrls + knowledge_base_texts stay in the DB either way, so
    // the empty-state Restore button can rebuild from them.
    if (
      isPythonBackend() &&
      remainingAfterSave === 0 &&
      pendingDeletes.length > 0
    ) {
      try {
        setEditBusy(true);
        setKbProcessingMsg("Removing all sources… You can restore them later.");
        setKbProcessing(true);
        const base = process.env.REACT_APP_PY_API_BASE_URL;
        const response = await fetch(`${base}/agents/${agent_id}/kb/clear`, {
          method: "POST",
          headers: authHeaders(),
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.detail || "Could not remove the knowledge base");
        }
        await fetchKnowledgeBaseDetails();
      } catch (error) {
        console.error("Python knowledge-base clear failed:", error);
        setInlineError("Could not remove the knowledge base. Please try again.");
      } finally {
        setKbProcessing(false);
        setPendingTexts([]);
        setSelectedFiles([]);
        setPendingDeletes([]);
        setPendingUrls([]);
        resetAddPanels();
        setEditBusy(false);
        savingRef.current = false;
        setShowEditModal(false);
      }
      return;
    }

    if (
      !isPythonBackend() &&
      remainingAfterSave === 0 &&
      pendingDeletes.length > 0
    ) {
      setPopup({
        show: true,
        type: "confirm",
        message:
          "A Knowledge Base must have at least one source. If you delete all sources, the Knowledge Base will also be removed from Rexpt database, which may affect agents using it.",
        onConfirm: () => {
          closePopup();
          deleteEntireKb();
        },
      });
      // Release the lock — deleteEntireKb manages its own busy state, and if the
      // user cancels the confirm, Save must be usable again.
      savingRef.current = false;
      return;
    }

    // Normal path — apply staged changes, refresh, close. The modal may already
    // be closed by the user (they clicked Close to keep working) — that's fine.
    try {
      setEditBusy(true);
      await applyAllChanges();
    } catch (e) {
      console.error("Save failed:", e);
      setKbProcessing(false); // clear banner on failure
      await fetchKnowledgeBaseDetails();
    } finally {
      // Clear staged data and reset busy AFTER the work is done, so a mid-save
      // Close didn't wipe the lists the operation was still using.
      setPendingTexts([]);
      setSelectedFiles([]);
      setPendingDeletes([]);
      setPendingUrls([]);
      resetAddPanels();
      setEditBusy(false);
      savingRef.current = false; // release the double-save lock
      setShowEditModal(false);
    }
  };

  // ---- Add Web Pages: step 1 crawl sitemap ----
  const runSitemap = async () => {
    const raw = urlInput.trim();
    if (!raw) return; // silently ignore empty URL
    try {
      setSitemapLoading(true);
      let urls = [];
      if (isPythonBackend()) {
        // Python agent: crawl via the Python service's own sitemap discovery
        // (POST /py/agents/{id}/kb/sitemap), which returns the same { data: {
        // urls } } page list Retell's list-sitemap does — so the picker below is
        // identical. Node's listSiteMap returns empty for Python, hence this.
        const base = process.env.REACT_APP_PY_API_BASE_URL;
        const r = await fetch(`${base}/agents/${agent_id}/kb/sitemap`, {
          method: "POST",
          headers: { ...authHeaders(), "Content-Type": "application/json" },
          body: JSON.stringify({ url: raw }),
        });
        const j = await r.json().catch(() => ({}));
        urls = Array.isArray(j?.data?.urls) ? j.data.urls : [];
      } else {
        const resp = await listSiteMap(raw);
        urls = Array.isArray(resp?.urls) ? resp.urls : [];
      }
      // If the crawl returns nothing, still let the user save the single URL.
      setSitemapUrls(urls.length ? urls : [raw]);
      const preselect = {};
      (urls.length ? urls : [raw]).forEach((u) => (preselect[u] = false));
      setSelectedSiteUrls(preselect);
    } catch (e) {
      // On crawl failure, fall back to saving just the entered URL.
      setSitemapUrls([raw]);
      setSelectedSiteUrls({ [raw]: true });
    } finally {
      setSitemapLoading(false);
    }
  };

  const toggleSiteUrl = (u) =>
    setSelectedSiteUrls((prev) => ({ ...prev, [u]: !prev[u] }));

  const filteredSiteUrls = (sitemapUrls || []).filter((u) =>
    u.toLowerCase().includes(siteSearch.toLowerCase())
  );

  const allFilteredSelected =
    filteredSiteUrls.length > 0 &&
    filteredSiteUrls.every((u) => selectedSiteUrls[u]);

  const toggleSelectAllSites = () => {
    const next = { ...selectedSiteUrls };
    const target = !allFilteredSelected;
    filteredSiteUrls.forEach((u) => (next[u] = target));
    setSelectedSiteUrls(next);
  };

  const selectedSiteCount = Object.values(selectedSiteUrls).filter(Boolean).length;

  // ---- Add Web Pages: STAGE selected URLs (no popup). Applied on main Save. ----
  const submitAddUrls = () => {
    const chosen = Object.keys(selectedSiteUrls).filter(
      (u) => selectedSiteUrls[u]
    );
    if (chosen.length === 0) return;
    setPendingUrls((prev) => [
      ...prev,
      // Skip urls that are already staged (prev) OR already in the KB — Retell
      // does NOT de-dupe, so re-selecting an existing url would create a second
      // identical source. This silently drops duplicates; only genuinely new
      // urls are added.
      ...chosen.filter(
        (u) => !prev.includes(u) && !existingKbUrlSet.has(String(u).trim())
      ),
    ]);
    setAddPanel(null);
    resetAddPanels();
  };

  const [popup, setPopup] = useState({
    show: false,
    type: "",
    message: "",
    onConfirm: null,
  });
  const closePopup = () => {
    setPopup({ show: false, type: "", message: "", onConfirm: null });
  };

  const fetchKnowledgeBaseDetails = async (kbIdOverride) => {
    // Use an explicit id when passed (e.g. right after a new KB is created and
    // React state hasn't updated yet), otherwise the current state value.
    const kbId = kbIdOverride || knowledgeBaseId;
    // Python agent (rexpt.in / port 3001): no Retell knowledge base. List the
    // files stored on the agent row via GET /py/agents/{id}/files and map them
    // into the same shape the Retell list renders (filename / source_id), so
    // the UI below needs no change. A Python agent has no knowledgeBaseId, so
    // this must run BEFORE the !kbId early-return that a Retell agent uses.
    if (isPythonBackend()) {
      setLoading(true);
      try {
        const base = process.env.REACT_APP_PY_API_BASE_URL;
        const resp = await fetch(`${base}/agents/${agent_id}/files`, {
          headers: authHeaders(),
        });
        const json = await resp.json().catch(() => ({}));
        // The Python /files endpoint now returns the FULL knowledge-base source
        // list in Retell's shape ({ data: { knowledge_base_sources, status } }):
        // the Business Details text, every scraped URL, and every uploaded file.
        // We render it with the SAME UI as a Retell agent — no per-type mapping
        // needed, the objects already carry type/title/url/filename/file_url.
        // Text sources carry a RELATIVE content_url (the download route on the
        // Python service); prepend the API base so the shared download button
        // (getDownloadUrl → href) points at the right host, like Retell's
        // absolute content_url. Files already carry an absolute file_url.
        const rawSources = json?.data?.knowledge_base_sources || [];
        const withText = rawSources.map((s) =>
          s?.type === "text" && s.content_url && s.content_url.startsWith("/")
            ? { ...s, content_url: `${base}${s.content_url.replace(/^\/py/, "")}` }
            : s
        );
        setKnowledgeBaseSources(withText);
      } catch (error) {
        console.error("Failed to fetch Python agent KB sources:", error);
        setKnowledgeBaseSources([]);
      } finally {
        setLoading(false);
      }
      return;
    }

    // Agent ke paas abhi koi KB nahi hai -> loader band karke empty state dikhao,
    // warna spinner hamesha ke liye atka reh jaata hai.
    // No KB (e.g. all sources were deleted so the KB was removed) → show the
    // empty state instead of calling getKnowledgeBase(null), which 404s.
    if (!kbId) {
      setKnowledgeBaseSources([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const response = await getKnowledgeBase(token, kbId);
      setKnowledgeBaseSources(response.data?.knowledge_base_sources || []);
      setLoading(false);
      // If the KB is still being crawled/ingested when the page loads, show the
      // banner and keep polling until it's complete.
      const status = response.data?.status;
      if (status && status !== "complete" && status !== "error") {
        waitForKbReady(kbId);
      }
    } catch (error) {
      console.error("Failed to fetch knowledge base details:", error);
    } finally {
      setLoading(false);
    }
  };

  const stopPolling = () => {
    if (pollRef.current) {
      clearInterval(pollRef.current);
      pollRef.current = null;
    }
  };

  const startPollingStatus = (kbId) => {
    if (!kbId) return;
    stopPolling();
    // ~2 min tak poll karo; Retell "in_progress" par atak jaaye to bhi
    // screen unblock rahe aur jo sources mile woh dikh jaayein.
    let attempts = 0;
    const MAX_ATTEMPTS = 24;

    const tick = async () => {
      attempts += 1;
      try {
        const response = await getKnowledgeBase(token, kbId);

        if (response?.success) {
          // Har tick par list update karo — "complete" hone ka wait mat karo,
          // warna indexing chalne tak nayi file dikhti hi nahi.
          setKnowledgeBaseSources(
            response?.data?.knowledge_base_sources || []
          );
          setLoading(false);

          if (response?.data?.status === "complete") {
            stopPolling();
            return;
          }
        }
      } catch (error) {
        console.error("Error while polling KB status:", error);
      }

      if (attempts >= MAX_ATTEMPTS) stopPolling();
    };

    // Pehla check turant — setInterval warna 5s baad hi chalta.
    tick();
    pollRef.current = setInterval(tick, 5000);
  };

  // Whenever navigation state explicitly carries an agent_id (the normal flow),
  // persist it so the storage fallback can never serve a PREVIOUS agent's id on
  // a later visit that lacks state (guards the stale-agent case).
  useEffect(() => {
    if (navState.agent_id) {
      sessionStorage.setItem("agent_id", navState.agent_id);
      localStorage.setItem("agent_id", navState.agent_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navState.agent_id]);

  // ALWAYS confirm the agent's CURRENT knowledgeBaseId from the backend whenever
  // we know the agent — do NOT rely on a knowledgeBaseId arriving via navigation
  // state or sessionStorage. Those sources are unreliable: some entry points
  // (e.g. the Calendar sidebar) don't pass a KB id at all, and a passed/stored
  // id can be stale after a delete-recreate. Depending on them is exactly what
  // made this page load correctly "sometimes" and show empty "sometimes".
  //
  // The DB (via getAgentById) is the single source of truth and is kept in sync
  // on delete/recreate, so this is deterministic: as long as agent_id resolves,
  // we get the right KB every time.
  //   - fresh id differs from what we have → adopt it (the KB fetch re-runs)
  //   - fresh id equals current       → setState is a no-op, no extra fetch
  //   - agent has no KB               → show empty state, stop the loader
  useEffect(() => {
    let cancelled = false;
    if (!agent_id) return undefined;
    // Python agents have NO Retell knowledgeBaseId — their KB source list comes
    // from the Python /files endpoint (handled by the [knowledgeBaseId] effect
    // below via fetchKnowledgeBaseDetails → isPythonBackend branch). Running the
    // Retell getAgentById→knowledgeBaseId resolution here would find no KB id and
    // wrongly clear the freshly-loaded Python sources. So skip this Retell-only
    // resolver entirely for a Python agent.
    if (isPythonBackend()) return undefined;
    getAgentById(agent_id)
      .then((res) => {
        if (cancelled) return;
        const freshKbId =
          res?.data?.agent?.knowledgeBaseId ||
          res?.data?.knowledgeBaseId ||
          null;
        if (freshKbId) {
          // setKnowledgeBaseId triggers the [knowledgeBaseId] effect below which
          // does the actual getKnowledgeBase call. If it's unchanged, React
          // bails the state update and the initial fetch (from mount) still ran.
          setKnowledgeBaseId(freshKbId);
          sessionStorage.setItem("knowledgeBaseId", freshKbId);
        } else {
          // Agent genuinely has no KB → clear any stale id + show empty state.
          setKnowledgeBaseId(null);
          setKnowledgeBaseSources([]);
          setLoading(false);
        }
      })
      .catch(() => {
        // Backend unreachable → fall back to whatever id we already have (if
        // any); the [knowledgeBaseId] effect handles the fetch/empty state.
        if (!cancelled && !knowledgeBaseId) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agent_id]);

  useEffect(() => {
    fetchKnowledgeBaseDetails(knowledgeBaseId);
  }, [knowledgeBaseId]);

  // Unmount par polling band — warna background interval chalta rehta hai.
  useEffect(() => stopPolling, []);
  const handleFileChange = (e) => {
    setInlineError("");
    const newFiles = Array.from(e.target.files);
    let validFiles = [];
    let oversizedFiles = [];
    let unsupportedFiles = [];

    // Validate file type + size
    newFiles.forEach((file) => {
      const ext = (file.name.split(".").pop() || "").toLowerCase();
      if (!ALLOWED_EXTENSIONS.includes(ext)) {
        unsupportedFiles.push(file.name);
      } else if (file.size / (1024 * 1024) > MAX_FILE_SIZE_MB) {
        oversizedFiles.push(file.name);
      } else {
        validFiles.push(file);
      }
    });

    const errs = [];
    if (unsupportedFiles.length > 0) {
      errs.push(
        `Unsupported format: ${unsupportedFiles.join(", ")}. Allowed: ${ALLOWED_EXTENSIONS.join(", ")}.`
      );
    }
    if (oversizedFiles.length > 0) {
      errs.push(
        `The following files exceed ${MAX_FILE_SIZE_MB}MB: ${oversizedFiles.join(", ")}`
      );
    }
    if (errs.length > 0) {
      setInlineError(errs.join(" "));
    }

    const combinedFiles = [...selectedFiles, ...validFiles];

    if (combinedFiles.length > MAX_FILES) {
      setPopup({
        show: true,
        type: "failed",
        message: `You can upload a maximum of ${MAX_FILES} files at a time.`,
        onConfirm: null,
      });
      return;
    }

    // Remove duplicates within the picked set (same name picked twice).
    const uniqueFiles = combinedFiles.filter(
      (file, index, self) =>
        index === self.findIndex((f) => f.name === file.name)
    );

    setSelectedFiles(uniqueFiles);
  };

  const handleRemoveFile = (fileName) => {
    const filtered = selectedFiles.filter((file) => file.name !== fileName);
    setSelectedFiles(filtered);
  };

  // const handleSubmit = async () => {
  //   if (!knowledgeBaseId || selectedFiles.length === 0) {
  //     setPopup({
  //       show: true,
  //       type: "failed",
  //       message: "Please select files",
  //       onConfirm: null,
  //     });
  //     return;
  //   }

  //   try {
  //     setIsModalDisabled(true); // disable modal

  //     setCancelButtonHeading(true);
  //     submitSetLoading(true);
  //     // Step 1: Upload files to the server
  //     const uploadResponse = await uploadAgentFiles(agent_id, selectedFiles);

  //     if (
  //       !uploadResponse ||
  //       !uploadResponse.files ||
  //       uploadResponse.files.length === 0
  //     ) {
  //       setPopup({
  //         show: true,
  //         type: "failed",
  //         message: "Failed to upload files to the server.",
  //         onConfirm: null,
  //       });
  //       return;
  //     }

  //     const newServerFileNames = uploadResponse.files.map(
  //       (file) => file.filename
  //     );
  //     localStorage.setItem(
  //       "newlyUploadedFiles",
  //       JSON.stringify(newServerFileNames)
  //     );

  //     // Step 2: Fetch server files
  //     const serverFilesResponse = await getAgentFiles(agent_id);
  //     const serverFiles = serverFilesResponse.files;

  //     if (!serverFiles || serverFiles.length === 0) {
  //       setPopup({
  //         show: true,
  //         type: "failed",
  //         message: "Failed to retrieve files from the server.",
  //         onConfirm: null,
  //       });
  //       localStorage.removeItem("newlyUploadedFiles");
  //       return;
  //     }

  //     const storedFileNames = JSON.parse(
  //       localStorage.getItem("newlyUploadedFiles") || "[]"
  //     );
  //     const filesForRetell = serverFiles.filter((serverFile) =>
  //       storedFileNames.includes(serverFile.name)
  //     );

  //     if (filesForRetell.length === 0) {
  //       setPopup({
  //         show: true,
  //         type: "failed",
  //         message: "No matching files found on the server to upload to Retell.",
  //         onConfirm: null,
  //       });
  //       localStorage.removeItem("newlyUploadedFiles");
  //       return;
  //     }

  //     // Step 3: Prepare formData for Retell
  //     const formData = new FormData();
  //     filesForRetell.forEach((file) => {
  //       const byteCharacters = atob(file.data);
  //       const byteNumbers = new Array(byteCharacters.length);
  //       for (let i = 0; i < byteCharacters.length; i++) {
  //         byteNumbers[i] = byteCharacters.charCodeAt(i);
  //       }
  //       const byteArray = new Uint8Array(byteNumbers);
  //       const blob = new Blob([byteArray], {
  //         type: "application/octet-stream",
  //       });
  //       const fileToUpload = new File([blob], file.name);

  //       formData.append("knowledge_base_files", fileToUpload);
  //       formData.append("filename", fileToUpload.name);
  //     });

  //     // Step 4: Upload to Retell
  //     const retellResponse = await addKnowledgeBaseSources(
  //       token,
  //       knowledgeBaseId,
  //       formData,
  //       agent_id
  //     );

  //     if (retellResponse?.success) {
  //       setShowModal(false); // Close the modal
  //       setSelectedFiles([]); // Clear selected files

  //       setPopup({
  //         show: true,
  //         type: "success",
  //         message: "Files uploaded successfully!",
  //         onConfirm: () => {
  //           fetchKnowledgeBaseDetails();
  //           closePopup();
  //         },
  //       });
  //       startPollingStatus(knowledgeBaseId);
  //       setTimeout(() => {
  //         setPopup({
  //           show: false,
  //         });
  //       }, 2000);
  //     } else {
  //       console.error("Upload failed with status:", retellResponse.status);
  //       setPopup({
  //         show: true,
  //         type: "failed",
  //         message: "Upload failed.",
  //         onConfirm: null,
  //       });
  //     }
  //     submitSetLoading(false);
  //   } catch (error) {
  //     submitSetLoading(false);
  //     setCancelButtonHeading(false);
  //     console.error("Error during upload:", error);
  //     setPopup({
  //       show: true,
  //       type: "failed",
  //       message: "Upload failed.",
  //       onConfirm: null,
  //     });
  //   } finally {
  //     setCancelButtonHeading(false);
  //     setIsModalDisabled(false);
  //     submitSetLoading(false);
  //     localStorage.removeItem("newlyUploadedFiles");
  //   }
  // };
  const handleSubmit = async () => {
    if (selectedFiles.length === 0) {
      setPopup({ show: true, type: "failed", message: "Please select files", onConfirm: null });
      return;
    }

    // Submit par dobara check — `accept` attribute sirf file dialog filter karta
    // hai, use bypass karna aasan hai. Yahan se aage sirf allowed formats jaate hain.
    const blocked = selectedFiles.filter(
      (file) => !isAllowedFile(file?.name)
    );
    if (blocked.length > 0) {
      setInlineError(
        `Unsupported format: ${blocked
          .map((f) => f.name)
          .join(", ")}. Allowed: ${SUPPORTED_LABEL}.`
      );
      setSelectedFiles((prev) => prev.filter((f) => isAllowedFile(f?.name)));
      return;
    }

    try {
      setIsModalDisabled(true);
      setCancelButtonHeading(true);
      submitSetLoading(true);

      // ── Python agent (rexpt.in / port 3001): no Retell knowledge base. Send
      // each file to the Python endpoint, which stores it (local or S3) and
      // folds its text into the Qdrant KB. Skip all the Retell steps below.
      // Node agent: isPythonBackend() is false → the original flow runs. ──
      if (isPythonBackend()) {
        const base = process.env.REACT_APP_PY_API_BASE_URL;
        for (const file of selectedFiles) {
          const fd = new FormData();
          fd.append("file", file);
          // For a multipart upload the browser MUST set Content-Type itself so
          // it can add the multipart boundary. authHeaders() forces
          // Content-Type: application/json, which breaks the boundary and makes
          // FastAPI reject the body with 422 — so strip it and keep only auth.
          const { "Content-Type": _ct, ...uploadHeaders } = authHeaders();
          const resp = await fetch(`${base}/agents/${agent_id}/files`, {
            method: "POST",
            headers: uploadHeaders,
            body: fd,
          });
          if (!resp.ok) {
            const err = await resp.json().catch(() => ({}));
            throw new Error(err.detail || `Upload failed for ${file.name}`);
          }
        }
        setSelectedFiles([]);
        // Close the upload modal on success (the Node branch does this too).
        // Without it the modal stayed open behind the success popup.
        setShowModal(false);
        setPopup({
          show: true,
          type: "success",
          message:
            "File uploaded. The agent's knowledge base is updating and will include it shortly.",
          onConfirm: null,
        });
        if (typeof fetchKnowledgeBaseDetails === "function") {
          fetchKnowledgeBaseDetails();
        }
        return;
      }

      // Step 1: Upload files to server
      const uploadResponse = await uploadAgentFiles(agent_id, selectedFiles);
      if (!uploadResponse?.files?.length) {
        setPopup({ show: true, type: "failed", message: "Failed to upload files to the server.", onConfirm: null });
        return;
      }

      const newServerFileNames = uploadResponse.files.map((file) => file.filename);
      localStorage.setItem("newlyUploadedFiles", JSON.stringify(newServerFileNames));

      // Step 2: Fetch server files
      const serverFilesResponse = await getAgentFiles(agent_id);
      const serverFiles = serverFilesResponse.files;
      if (!serverFiles?.length) {
        setPopup({ show: true, type: "failed", message: "Failed to retrieve files from the server.", onConfirm: null });
        localStorage.removeItem("newlyUploadedFiles");
        return;
      }

      const storedFileNames = JSON.parse(localStorage.getItem("newlyUploadedFiles") || "[]");
      const filesForRetell = serverFiles.filter((serverFile) =>
        storedFileNames.includes(serverFile.name)
      );

      if (!filesForRetell.length) {
        setPopup({ show: true, type: "failed", message: "No matching files found on the server.", onConfirm: null });
        localStorage.removeItem("newlyUploadedFiles");
        return;
      }

      // Step 3: Prepare formData
      const formData = new FormData();
      filesForRetell.forEach((file) => {
        const byteCharacters = atob(file.data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        // Sahi content-type zaroori hai: octet-stream par Retell source to bana
        // deta hai par text extract nahi karta — file dikhti hai, data khaali.
        const contentType = guessMimeType(file.name, file.mimetype);
        const blob = new Blob([byteArray], { type: contentType });
        const fileToUpload = new File([blob], file.name, { type: contentType });
        formData.append("knowledge_base_files", fileToUpload);
        formData.append("filename", fileToUpload.name);
      });

      // Step 4: Upload to Retell (pass current knowledgeBaseId — could be null/old)
      const retellResponse = await addKnowledgeBaseSources(
        token,
        knowledgeBaseId,   // could be old or null
        formData,
        agent_id
      );

      if (retellResponse?.success) {
        // ✅ KEY FIX: If backend created a new KB, update state with new KB ID
        const activeKbId =
          retellResponse.newKnowledgeBaseId ||  // new KB was created
          retellResponse.knowledgeBaseId ||      // existing KB was used
          knowledgeBaseId;                       // fallback to current

        setShowModal(false);
        setSelectedFiles([]);

        if (activeKbId && activeKbId !== knowledgeBaseId) {
          // Naya KB bana — id badalne par useEffect khud refetch kar dega.
          console.log("[KB] New KB ID received, updating state:", activeKbId);
          setKnowledgeBaseId(activeKbId);
        } else {
          // KB id wahi hai, isliye useEffect trigger nahi hoga — list khud
          // refresh karni padegi, warna user ko manually refresh karna padta hai.
          await fetchKnowledgeBaseDetails(activeKbId);
        }

        setPopup({
          show: true,
          type: "success",
          message: "Files uploaded successfully ! Please wait for 10-15 seconds for indexing to complete,Then refresh the page.",
          onConfirm: closePopup,
        });

        // Retell file ko background mein index karta hai, isliye source turant
        // list mein na aaye to polling use pakad legi.
        startPollingStatus(activeKbId);

        setTimeout(() => setPopup({ show: false }), 2000);
      } else {
        setPopup({ show: true, type: "failed", message: "Upload failed.", onConfirm: null });
      }

    } catch (error) {
      console.error("Error during upload:", error);
      setPopup({ show: true, type: "failed", message: "Upload failed.", onConfirm: null });
    } finally {
      setCancelButtonHeading(false);
      setIsModalDisabled(false);
      submitSetLoading(false);
      localStorage.removeItem("newlyUploadedFiles");
    }
  };
  const performDelete = async (sourceId) => {
    const fileToDelete = knowledgeBaseSources.find(
      (source) => source.source_id === sourceId
    );
    if (!fileToDelete) {
      setPopup({
        show: true,
        type: "failed",
        message: "Could not find file to delete.",
        onConfirm: null,
      });
      return;
    }
    const filename = fileToDelete.filename;
    try {
      // Python agent: no Retell source to delete. The mapped source_id IS the
      // stored path, so send it to DELETE /py/agents/{id}/files, which detaches
      // the file and rebuilds the Qdrant KB without it. Skip the Retell calls.
      if (isPythonBackend()) {
        const base = process.env.REACT_APP_PY_API_BASE_URL;
        const resp = await fetch(`${base}/agents/${agent_id}/files`, {
          method: "DELETE",
          headers: { ...authHeaders(), "Content-Type": "application/json" },
          body: JSON.stringify({ path: sourceId }),
        });
        if (!resp.ok) {
          const err = await resp.json().catch(() => ({}));
          throw new Error(err.detail || "Delete failed");
        }
        setKnowledgeBaseSources((prevSources) =>
          prevSources.filter((source) => source.source_id !== sourceId)
        );
        setPopup({
          show: true,
          type: "success",
          message: "File deleted successfully!",
          onConfirm: () => {
            closePopup();
          },
        });
        return;
      }

      await deleteKnowledgeBaseSource(token, knowledgeBaseId, sourceId);
      setKnowledgeBaseSources((prevSources) =>
        prevSources.filter((source) => source.source_id !== sourceId)
      );
      const localServerResponse = await deleteAgentFile(agent_id, filename);
      setPopup({
        show: true,
        type: "success",
        message: "File deleted successfully!",
        onConfirm: () => {
          closePopup();
        },
      });
    } catch (error) {
      console.error("Delete failed:", error);
      setPopup({
        show: true,
        type: "failed",
        message: "Delete failed",
        onConfirm: null,
      });
    }
  };

  const handleDeleteSource = (sourceId) => {
    setPopup({
      show: true,
      type: "confirm",
      message: "Are you sure you want to delete this file?",
      onConfirm: () => performDelete(sourceId),
    });
  };

  return (
    /* DesktopShell renders nothing below 992px, so mobile is unchanged. The
       floating "+" is a mobile affordance — on desktop the same action sits in
       the top bar (the in-page button is CSS-hidden there). */
    // <DesktopShell
    //   sidebarItems={buildSidebarItems({ navigate, activeKey: "knowledge-base" })}
    //   title="Knowledge Base"
    //   subtitle="Files your agent uses to answer questions."
    //   actions={
    //     <button
    //       type="button"
    //       className={styles.deskAddBtn}
    //       onClick={() => openEditModal()}
    //     >
    //       <img
    //         src="/svg/edit-icon.svg"
    //         alt="edit"
    //         className={styles.editIcon}
    //       />
    //       Edit
    //     </button>
    //   }
    // >
    <div className={styles.containerBox}>
      <div className={styles.container}>
        <div className={styles.Forsticky}>
          {/* Edit button is passed as HeaderBar's rightIcon so it aligns with
              the "Knowledge Files" title (like Retell's top-right Edit).
              OLD "+" button kept (commented) in case we need direct upload again:
              <div onClick={() => setShowModal(true)} className={styles.addButton}>
                <img src="/svg/Add-icon.svg" />
              </div> */}
          <HeaderBar
            title="Knowledge Files"
            rightIcon={
              <button
                type="button"
                onClick={() => openEditModal()}
                className={styles.editButton}
              >
                <img
                  src="/svg/edit-icon.svg"
                  alt="edit"
                  className={styles.editIcon}
                />
                Edit
              </button>
            }
          />
        </div>
        <br />
        {/* Processing banner — shown while a KB operation (crawl/ingest OR
            delete) is running. Message varies by operation. */}
        {kbProcessing && (
          <div className={styles.processingBanner}>
            <span className={styles.processingSpinner} />
            <span>
              {kbProcessingMsg ||
                "Processing your knowledge base… This can take a moment. You can keep working — it will update automatically."}
            </span>
          </div>
        )}
        <div className={styles.fileListHeader}>
          {loading ? (
            <Loader2 />
          ) : (
            (() => {
              // Show ALL sources of THIS agent's KB, like Retell. URL sources are
              // grouped by domain into one expandable card ("N Pages").
              const sources = Array.isArray(knowledgeBaseSources)
                ? knowledgeBaseSources
                : [];

              // While the KB is processing and no sources are listed yet, show
              // nothing here — the processing banner above already explains it.
              // Avoids a misleading "No data" flashing over a KB that's just
              // ingesting. (Only shows "No data" when truly empty AND idle.)
              if (sources.length === 0 && kbProcessing) {
                return null;
              }

              if (sources.length === 0) {
                // Preserve Anubhav's desktop empty-state (Desktop UI Dashboard
                // V1.1). Mobile keeps the plain "No data" line; desktop shows the
                // illustrated state. Both are in the DOM; CSS shows one per
                // breakpoint. Button opens our Edit modal (was setShowModal).
                return (
                  <>
                    <p className={styles.noData}>No data</p>

                    <div className={styles.emptyState}>
                      {/* Documents being read into the agent's knowledge. */}
                      <svg
                        className={styles.emptyArt}
                        viewBox="0 0 260 150"
                        fill="none"
                        role="img"
                        aria-label="Documents feeding into your agent's knowledge"
              // Sirf file-type sources dikhao (URL/text sources ka filename nahi hota).
              // Pehle yahan filename mein ek localStorage-based "KB-XXXX" code bhi
              // match hota tha, jiski wajah se onboarding se aayi files aur
              // storage clear hone ke baad ki saari files "No data" ban jaati thi.
//               const fileSources = knowledgeBaseSources.filter(
//                 (source) => source?.filename
//               );

//               return fileSources.length > 0 ? (
//                 fileSources.map((source) => (
//                   <li key={source.source_id} className={styles.uploadedFileItem}>
//                     <div className={styles.uploadedFileName}>
//                       <span title={source.filename}>{source.filename}</span>
//                     </div>
//                     <div className={styles.fileActions}>
//                       <a
//                         href={source.file_url}
//                         download
//                         className={styles.iconButton}
//                         title="Download"
                      >
                        {/* stacked documents */}
                        <rect x="26" y="34" width="66" height="84" rx="8" fill="#EFEBFB" stroke="#E4E0F2" />
                        <rect x="38" y="26" width="66" height="84" rx="8" fill="#F7F5FF" stroke="#E4E0F2" />
                        <rect x="50" y="18" width="66" height="84" rx="8" fill="#fff" stroke="#DED8F3" />
                        <rect x="60" y="32" width="46" height="7" rx="3.5" fill="#DED8F3" />
                        <rect x="60" y="46" width="36" height="7" rx="3.5" fill="#EDEAF8" />
                        <rect x="60" y="60" width="42" height="7" rx="3.5" fill="#EDEAF8" />
                        <rect x="60" y="74" width="28" height="7" rx="3.5" fill="#EDEAF8" />

                        {/* flow arrow */}
                        <path d="M128 60h22" stroke="#C9B8F5" strokeWidth="2" strokeLinecap="round" />
                        <path d="M146 55l5 5-5 5" stroke="#C9B8F5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />

                        {/* the agent */}
                        <circle cx="196" cy="60" r="30" fill="#6524EB" />
                        <path
                          d="M186 50h20a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3h-8l-5 5v-5h-7a3 3 0 0 1-3-3V53a3 3 0 0 1 3-3Z"
                          fill="#fff"
                        />
                        <circle cx="191" cy="59" r="1.8" fill="#6524EB" />
                        <circle cx="196" cy="59" r="1.8" fill="#6524EB" />
                        <circle cx="201" cy="59" r="1.8" fill="#6524EB" />
                      </svg>

                      <h3 className={styles.emptyTitle}>No files yet</h3>
                      <p className={styles.emptyText}>
                        Upload the documents your agent should know — price lists,
                        service details, policies, FAQs. It reads them and uses the
                        answers on live calls, so callers get the same information
                        you would give them.
                      </p>

                      <div className={styles.emptyActions}>
                        <button
                          type="button"
                          className={styles.emptyBtn}
                          onClick={() => openEditModal()}
                        >
                          <span aria-hidden="true">+</span> Add your file
                        </button>

                        {/* App ka standard AnimatedButton, in-flow (fixed nahi) */}
                        <AnimatedButton
                          label="Restore your knowledge base"
                          onClick={() => handleRestoreKnowledgeBase()}
                          positionType="relative"
                          width="100%"
                          bottom="0"
                        />
                      </div>

                      <p className={styles.emptyHint}>
                        PDF, MD or TXT work best. You can add more any time.
                      </p>
                    </div>
                  </>
                );
              }

              const { urlGroups, others } = groupSources(sources);

              return (
                <>
                  {/* ---- URL cards, grouped by domain (like Retell) ---- */}
                  {urlGroups.map((group) => {
                    const pageCount = group.pages.length;
                    const isOpen = !!expandedUrls[group.host];
                    return (
                      <div key={group.host} className={styles.kbCard}>
                        <div
                          className={styles.kbCardHead}
                          onClick={() => toggleUrlExpand(group.host)}
                        >
                          <span className={styles.kbBadgeUrl}>URL</span>
                          <div className={styles.kbCardTitleWrap}>
                            <span
                              className={styles.kbCardTitle}
                              title={group.host}
                            >
                              {group.host}
                            </span>
                            <span className={styles.kbCardSub}>
                              {pageCount} {pageCount === 1 ? "Page" : "Pages"}
                            </span>
                          </div>
                          <span className={styles.kbChevron}>
                            {isOpen ? "▲" : "▼"}
                          </span>
                        </div>
                        {isOpen && (
                          <div className={styles.kbPageList}>
                            {group.pages.map((p) => (
                              <a
                                key={p.source_id}
                                href={p.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.kbPageLink}
                              >
                                {p.url}
                              </a>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {/* ---- TEXT + FILE cards ---- */}
                  {others.map((source) => {
                    if (source.type === "text") {
                      const textName = source.title || source.name || "Text";
                      const dl = getDownloadUrl(source);
                      return (
                        <div key={source.source_id} className={styles.kbCard}>
                          <div className={styles.kbCardHead}>
                            <span className={styles.kbBadgeText}>TEXT</span>
                            <div className={styles.kbCardTitleWrap}>
                              <span
                                className={styles.kbCardTitle}
                                title={textName}
                              >
                                {textName}
                              </span>
                              <span className={styles.kbCardSub}>
                                {formatSize(source.file_size)}
                              </span>
                            </div>
                            {dl && (
                              <a
                                href={dl}
                                download={`${textName}.txt`}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={
                                  isPythonBackend()
                                    ? (event) =>
                                        downloadPythonText(event, source, textName)
                                    : undefined
                                }
                                className={styles.iconButton}
                                title="Download"
                              >
                                <img
                                  src="/svg/download-invoice.svg"
                                  alt="download"
                                />
                              </a>
                            )}
                          </div>
                        </div>
                      );
                    }

                    // FILE (document)
                    const dl = getDownloadUrl(source);
                    return (
                      <div key={source.source_id} className={styles.kbCard}>
                        <div className={styles.kbCardHead}>
                          <span className={styles.kbBadgeFile}>FILE</span>
                          <div className={styles.kbCardTitleWrap}>
                            <span
                              className={styles.kbCardTitle}
                              title={source.filename}
                            >
                              {source.filename}
                            </span>
                            {source.file_size != null && (
                              <span className={styles.kbCardSub}>
                                {formatSize(source.file_size)}
                              </span>
                            )}
                          </div>
                          <div className={styles.fileActions}>
                            {dl && (
                              <a
                                href={dl}
                                download
                                className={styles.iconButton}
                                title="Download"
                              >
                                <img
                                  src="/svg/download-invoice.svg"
                                  alt="download-invoice"
                                />
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              );
            })()
          )}
        </div>

        {showModal && (
          <div className={styles.modalOverlay}>
            <div
              className={`${styles.modalContent} ${isModalDisabled ? styles.disabled : ""
                }`}
            >
              <h2 className={styles.modalTitle}>Upload Files (Max 1)</h2>
              <hr />

              <div className={styles.uploadGuidelines}>
                <p className={styles.capsul}> Supported Files</p>
                {/* Old full list — kept for future re-enable:
                <p>
                  {SUPPORTED_LABEL}
                  <br />
                </p> */}
                <p>
                  {ACCEPT_ATTR}
                  <br />
                </p>{" "}
              </div>

              <p className={styles.suportfile}>
                {" "}
                For <b>CSV, XLS, and XLSX</b> files specifically, there are
                additional limits of
                <b> 1,000 rows</b> and <b>50 columns</b>.
                <br />
              </p>

              <input
                id="file-upload"
                type="file"
                multiple
                onChange={handleFileChange}
                className={styles.fileInput}
                accept={ACCEPT_ATTR}
              />
              <p className={styles.maxlimit}>
                Maximum file size limit: <b>{MAX_FILE_SIZE_MB}MB</b>.
              </p>
              {inlineError && <p className={styles.inlineError}>{inlineError}</p>}
              <ul className={styles.selectedFileList}>
                {selectedFiles.map((file, index) => (
                  <li key={index} className={styles.fileItem}>
                    <span>{file.name}</span>
                    <button
                      type="button"
                      className={styles.removeFileButton}
                      onClick={() => handleRemoveFile(file.name)}
                    >
                      &times;
                    </button>
                  </li>
                ))}
              </ul>
              <div className={styles.modalActions}>
                <button
                  onClick={() => {
                    setShowModal(false);
                    setSelectedFiles([]);
                  }}
                  disabled={cancelButtonHeading}
                  className={styles.cancelButton}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className={styles.submitButton}
                  disabled={selectedFiles.length === 0}
                >
                  {submitLoading ? (
                    <div style={{ display: "flex" }}>
                      <Loader size={16} />
                      &nbsp; Submitting
                    </div>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ============ EDIT KNOWLEDGE BASE MODAL (Retell-style) ============ */}
        {showEditModal && (
          <div className={styles.modalOverlay}>
            {/* Hidden file input — the OS picker opens directly when the user
                clicks "Upload Files"; once a file is chosen we open the popup. */}
            <input
              ref={uploadInputRef}
              type="file"
              multiple
              style={{ display: "none" }}
              accept={ACCEPT_ATTR}
              onChange={(e) => {
                // Just stage the file(s) as pending rows in the Documents list.
                // The modal's main Save uploads them. No separate popup.
                handleFileChange(e);
              }}
            />
            <div className={styles.editModal}>
              <div className={styles.editHeader}>
                <h2 className={styles.editTitle}>Edit Knowledge Base</h2>
                <button
                  className={styles.editClose}
                  onClick={closeEditModal}
                  title="Close"
                >
                  &times;
                </button>
              </div>

              <div className={styles.editBody}>
              {/* ---- Documents list (grouped like Retell, each with delete) ---- */}
              <div className={styles.editSectionLabel}>Documents</div>
              <div className={styles.editDocList}>
                {(() => {
                    // Hide sources the user staged for deletion (applied on Save).
                    const visibleSources = knowledgeBaseSources.filter(
                      (s) => !pendingDeletes.includes(s.source_id)
                    );
                    const nothingToShow =
                      visibleSources.length === 0 &&
                      pendingTexts.length === 0 &&
                      pendingUrls.length === 0 &&
                      selectedFiles.length === 0;
                    if (nothingToShow) {
                      return <p className={styles.noData}>No documents yet</p>;
                    }
                    // Merge pending URLs into the source list as pseudo url-sources
                    // so they group by hostname WITH existing ones (one card each).
                    const pendingUrlSources = pendingUrls.map((u, i) => ({
                      type: "url",
                      url: u,
                      source_id: `__pendingurl_${i}`,
                    }));
                    const { urlGroups, others } = groupSources([
                      ...visibleSources,
                      ...pendingUrlSources,
                    ]);
                    return (
                      <>
                        {/* URL groups — delete removes every page of that domain */}
                        {urlGroups.map((group) => (
                          <div
                            key={group.host}
                            className={styles.editDocRow}
                          >
                            <span className={styles.kbBadgeUrl}>URL</span>
                            <div className={styles.editDocInfo}>
                              <span
                                className={styles.editDocName}
                                title={group.host}
                              >
                                {group.host}
                              </span>
                              <span className={styles.kbCardSub}>
                                {group.pages.length}{" "}
                                {group.pages.length === 1 ? "Page" : "Pages"}
                              </span>
                            </div>
                            <button
                              className={styles.iconButton}
                              title="Delete"
                              disabled={editBusy}
                              onClick={() => editDeleteUrlGroup(group)}
                            >
                              <img src="/svg/delete-invoice.svg" alt="delete" />
                            </button>
                          </div>
                        ))}

                        {/* TEXT + FILE rows */}
                        {others.map((source) => {
                          const isText = source.type === "text";
                          const label = isText
                            ? source.title || source.name || "Text"
                            : source.filename;
                          return (
                            <div
                              key={source.source_id}
                              className={styles.editDocRow}
                            >
                              <span
                                className={
                                  isText
                                    ? styles.kbBadgeText
                                    : styles.kbBadgeFile
                                }
                              >
                                {isText ? "TEXT" : "FILE"}
                              </span>
                              <div className={styles.editDocInfo}>
                                <span
                                  className={styles.editDocName}
                                  title={label}
                                >
                                  {label}
                                </span>
                              </div>
                              <button
                                className={styles.iconButton}
                                title="Delete"
                                disabled={editBusy}
                                onClick={() => editDeleteSource(source)}
                              >
                                <img
                                  src="/svg/delete-invoice.svg"
                                  alt="delete"
                                />
                              </button>
                            </div>
                          );
                        })}
                      </>
                    );
                  })()}

                {/* (Pending web-page URLs are merged into their hostname's URL
                    card above, so they show as one card — no separate row.) */}

                {/* Pending TEXT just added (not uploaded until Save) */}
                {pendingTexts.map((t, index) => (
                  <div
                    key={`ptext-${index}`}
                    className={`${styles.editDocRow} ${styles.pendingRow}`}
                  >
                    <span className={styles.kbBadgeText}>TEXT</span>
                    <div className={styles.editDocInfo}>
                      <span className={styles.editDocName} title={t.title}>
                        {t.title}
                      </span>
                    </div>
                    <button
                      className={styles.iconButton}
                      title="Remove"
                      disabled={submitLoading}
                      onClick={() =>
                        setPendingTexts((prev) =>
                          prev.filter((_, i) => i !== index)
                        )
                      }
                    >
                      <img src="/svg/delete-invoice.svg" alt="remove" />
                    </button>
                  </div>
                ))}

                {/* Pending files just picked (not uploaded until Save).
                    Skip any pending file that ALREADY exists as a saved source.
                    During a save, applyAllChanges refreshes knowledgeBaseSources
                    (the file now appears with its "-<timestamp>-<rand>" suffix)
                    BEFORE selectedFiles is cleared in the finally block — so for
                    a moment the same file rendered twice: once as the saved
                    source and once as this pending row. Matching by base name
                    (suffix stripped) hides the pending twin the instant its
                    saved copy shows up, so you never see the file two times. */}
                {(() => {
                  const savedDocBases = new Set(
                    (knowledgeBaseSources || [])
                      .filter(
                        (s) =>
                          s?.type === "document" &&
                          s?.filename &&
                          !pendingDeletes.includes(s.source_id)
                      )
                      .map((s) => fileBaseNameOf(s.filename))
                  );
                  return selectedFiles.filter(
                    (file) => !savedDocBases.has(fileBaseNameOf(file.name))
                  );
                })().map((file, index) => (
                  <div
                    key={`pending-${index}`}
                    className={`${styles.editDocRow} ${styles.pendingRow}`}
                  >
                    <span className={styles.kbBadgeFile}>FILE</span>
                    <div className={styles.editDocInfo}>
                      <span className={styles.editDocName} title={file.name}>
                        {file.name}
                      </span>
                    </div>
                    <button
                      className={styles.iconButton}
                      title="Remove"
                      disabled={submitLoading}
                      onClick={() => handleRemoveFile(file.name)}
                    >
                      <img src="/svg/delete-invoice.svg" alt="remove" />
                    </button>
                  </div>
                ))}
                {inlineError && (
                  <p className={styles.inlineError}>{inlineError}</p>
                )}
              </div>

              {/* ---- "+ Add" dropdown ---- */}
              {!addPanel && (
                <div className={styles.addWrap}>
                  <button
                    ref={addBtnRef}
                    className={styles.addBtn}
                    onClick={toggleAddMenu}
                    disabled={editBusy}
                  >
                    + Add
                    <span
                      className={`${styles.addBtnCaret} ${
                        addMenuOpen ? styles.addBtnCaretOpen : ""
                      }`}
                      aria-hidden="true"
                    >
                      ▼
                    </span>
                  </button>
                  {addMenuOpen &&
                    createPortal(
                    <div
                      className={styles.addMenu}
                      role="menu"
                      style={{
                        top: addMenuPos.top,
                        left: addMenuPos.left,
                        ...(addMenuPos.width ? { width: addMenuPos.width } : {}),
                        ...(addMenuPos.maxHeight
                          ? { maxHeight: addMenuPos.maxHeight }
                          : {}),
                      }}
                      onMouseDown={(e) => e.stopPropagation()}
                    >
                      <button
                        role="menuitem"
                        onClick={() => {
                          setAddPanel("url");
                          setAddMenuOpen(false);
                        }}
                      >
                        <span className={styles.addMenuIcon} aria-hidden="true">
                          <svg viewBox="0 0 24 24" fill="none">
                            <path
                              d="M10 13a5 5 0 0 0 7.07 0l2.83-2.83a5 5 0 1 0-7.07-7.07L11.5 4.5"
                              stroke="currentColor"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M14 11a5 5 0 0 0-7.07 0L4.1 13.83a5 5 0 0 0 7.07 7.07l1.32-1.32"
                              stroke="currentColor"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <span className={styles.addMenuText}>
                          <b>Add Web Pages</b>
                          <span>Crawl and sync your website</span>
                        </span>
                      </button>
                      <button role="menuitem" onClick={openUploadPicker}>
                        <span className={styles.addMenuIcon} aria-hidden="true">
                          <svg viewBox="0 0 24 24" fill="none">
                            <path
                              d="M12 16V4m0 0L7 9m5-5 5 5"
                              stroke="currentColor"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3"
                              stroke="currentColor"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <span className={styles.addMenuText}>
                          <b>Upload Files</b>
                          <span>
                            File size should be less than {MAX_FILE_SIZE_MB}MB
                          </span>
                          <span className={styles.addMenuFormats}>
                            Supported: {ACCEPT_ATTR}
                          </span>
                        </span>
                      </button>
                      <button
                        role="menuitem"
                        onClick={() => {
                          setAddPanel("text");
                          setAddMenuOpen(false);
                        }}
                      >
                        <span className={styles.addMenuIcon} aria-hidden="true">
                          <svg viewBox="0 0 24 24" fill="none">
                            <path
                              d="M4 7V5h16v2M9 5v14m-2 0h4"
                              stroke="currentColor"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <span className={styles.addMenuText}>
                          <b>Add Text</b>
                          <span>Add articles manually</span>
                        </span>
                      </button>
                    </div>,
                    document.body,
                  )}
                </div>
              )}

              </div>

              {/* ---- Bottom bar ---- */}
              <div className={styles.editFooter}>
                {/* Cancel stays enabled: while saving it just closes the modal —
                    the work keeps running in the background. */}
                <button
                  className={styles.cancelButton}
                  onClick={closeEditModal}
                >
                  {editBusy ? "Close" : "Cancel"}
                </button>
                <button
                  className={styles.submitButton}
                  onClick={() => handleEditSave()}
                  disabled={editBusy}
                >
                  {editBusy ? (
                    <div style={{ display: "flex" }}>
                      <Loader size={16} />
                      &nbsp; Saving
                    </div>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </div>

            {/* ===== Stacked popup: Add Text (on top of Edit modal) ===== */}
            {addPanel === "text" && (
              <div className={styles.stackOverlay}>
                <div className={styles.stackModal}>
                  <div className={styles.editHeader}>
                    <h3 className={styles.editTitle}>Add Text</h3>
                    <button
                      className={styles.editClose}
                      onClick={() => {
                        setAddPanel(null);
                        resetAddPanels();
                      }}
                    >
                      &times;
                    </button>
                  </div>
                  <label className={styles.subLabel}>File Name</label>
                  <input
                    className={styles.subInput}
                    placeholder="Enter file name"
                    value={textName}
                    onChange={(e) => setTextName(e.target.value)}
                  />
                  <label className={styles.subLabel}>Text Content</label>
                  <textarea
                    className={styles.subTextarea}
                    placeholder="Enter text content"
                    value={textContent}
                    onChange={(e) => setTextContent(e.target.value)}
                  />
                  <div className={styles.editFooter}>
                    <button
                      className={styles.cancelButton}
                      onClick={() => {
                        setAddPanel(null);
                        resetAddPanels();
                      }}
                      disabled={editBusy}
                    >
                      Cancel
                    </button>
                    <button
                      className={styles.submitButton}
                      onClick={stageAddText}
                      disabled={editBusy}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* ===== Stacked popup: Add Web Pages (URL entry) ===== */}
            {addPanel === "url" && sitemapUrls === null && (
              <div className={styles.stackOverlay}>
                <div className={styles.stackModal}>
                  <div className={styles.editHeader}>
                    <h3 className={styles.editTitle}>Add Web Pages</h3>
                    <button
                      className={styles.editClose}
                      onClick={() => {
                        setAddPanel(null);
                        resetAddPanels();
                      }}
                    >
                      &times;
                    </button>
                  </div>
                  <label className={styles.subLabel}>URL Address</label>
                  <input
                    className={styles.subInput}
                    placeholder="Enter URL"
                    value={urlInput}
                    onChange={(e) => setUrlInput(e.target.value)}
                  />
                  <div className={styles.editFooter}>
                    <button
                      className={styles.cancelButton}
                      onClick={() => {
                        setAddPanel(null);
                        resetAddPanels();
                      }}
                      disabled={sitemapLoading}
                    >
                      Cancel
                    </button>
                    <button
                      className={styles.submitButton}
                      onClick={runSitemap}
                      disabled={sitemapLoading}
                    >
                      {sitemapLoading ? (
                        <div style={{ display: "flex" }}>
                          <Loader size={16} />
                          &nbsp; Scanning
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* ===== Stacked popup: Select Site Maps (page picker) ===== */}
            {addPanel === "url" && sitemapUrls !== null && (
              <div className={styles.stackOverlay}>
                <div className={styles.stackModalWide}>
                  <div className={styles.editHeader}>
                    <h3 className={styles.editTitle}>Select Site Maps</h3>
                    <button
                      className={styles.editClose}
                      onClick={() => {
                        setAddPanel(null);
                        resetAddPanels();
                      }}
                    >
                      &times;
                    </button>
                  </div>
                  <input
                    className={styles.subInput}
                    placeholder="Search..."
                    value={siteSearch}
                    onChange={(e) => setSiteSearch(e.target.value)}
                  />
                  <label className={styles.selectAllRow}>
                    <input
                      type="checkbox"
                      checked={allFilteredSelected}
                      onChange={toggleSelectAllSites}
                    />
                    Select All ({filteredSiteUrls.length})
                  </label>
                  <div className={styles.siteList}>
                    {filteredSiteUrls.map((u) => (
                      <label key={u} className={styles.siteRow}>
                        <input
                          type="checkbox"
                          checked={!!selectedSiteUrls[u]}
                          onChange={() => toggleSiteUrl(u)}
                        />
                        <span title={u}>{u}</span>
                      </label>
                    ))}
                  </div>
                  <div className={styles.siteFooter}>
                    {selectedSiteCount} selected
                  </div>
                  <div className={styles.editFooter}>
                    <button
                      className={styles.cancelButton}
                      onClick={() => {
                        setAddPanel(null);
                        resetAddPanels();
                      }}
                      disabled={editBusy}
                    >
                      Cancel
                    </button>
                    <button
                      className={styles.submitButton}
                      onClick={submitAddUrls}
                      disabled={editBusy || selectedSiteCount === 0}
                    >
                      {editBusy ? "Saving..." : "Save"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* The PopUp component is rendered here */}
        {popup.show && (
          <PopUp
            type={popup.type}
            message={popup.message}
            onClose={closePopup}
            onConfirm={popup.onConfirm}
          />
        )}
      </div>
    </div>
    /* </DesktopShell> */
  );
};

export default Fileinfo;
